module.exports = {
	"general.formats.dayFormattingPattern": "MMMM DD, YYYY",
	"general.formats.datePatternAPI": "YYYY-MM-DD",
	"general.formats.datePatternUI": "MM-DD-YYYY",
	"general.formats.shortDatePattern": "MMM DD",
	"general.formats.fullShortDatePattern": "MMM DD, YYYY",
	"general.formats.timePattern": "hh:mm a",
	"general.title": "{brandName}",
	"general.description": "Healthcare delivery outside of hospital",
	"general.slogan.primary": "The global network for patient engagement",
	"general.slogan.secondary": "Patient engagement - anywhere, anytime",
	"general.labels.you": "(You)",
	"general.labels.or": "or",
	"general.labels.me": "Me",
	"general.labels.YO": "y.o.",
	"general.labels.noInternet": "No internet connection",
	"general.labels.myProfile": "My profile",
	"general.labels.profile": "Profile",
	"general.labels.profiles": "Profiles",
	"general.labels.backToInvitation": "Back to invitation process",
	"general.labels.userNameExample": "JohnDoe_123 or Wolverine",
	"general.labels.userNameExplanation": "Nickname is an alias that will be used to identify yourself in your postings. Be creative if you prefer to be anonymous.",
	"general.labels.pickItemLeft": "Pick an item you’d like to view in the left sidebar",
	"general.errors.404": "Oops! There is nothing to see here.",
	"general.toTop": "Go to the top",
	"general.success": "Success",
	"general.completed": "Completed",
	"general.todo": "To Do",
	"general.removedFromChat": "You’ve been deleted from this chat",
	"general.viewOnMap": "View on the map",
	"general.addToCalendar": "Add to calendar",
	"general.search.placeholder": "Search...",
	"general.search.patients": "Search patients...",
	"general.search.tabs.people": "Add People",
	"general.search.tabs.teams": "Add Teams",
	"general.search.tabs.providers": "Add Proiders",
	"general.search.searchByPeopleUsername": "Search people by their username…",
	"general.search.noOneFound": "No one found",
	"pages.title.messages": "Messaging",
	"pages.title.virtualRoom": "Virtual Room",
	"pages.title.accessDenied": "Access Denied",
	"pages.title.expiredToken": "Expired Token",
	"pages.title.expiredLink": "Expired Link",
	"pages.title.expiredConfirmation": "Expired Confirmation",
	"pages.title.login": "Login",
	"pages.title.signup": "Sign Up",
	"pages.title.signupInvite": "Sign Up Invitation",
	"pages.title.signupAzure": "Sign Up (Azure)",
	"pages.title.recoverPassword": "Recover Password",
	"pages.title.changePassword": "Change Password",
	"pages.title.createPassword": "Create Password",
	"pages.title.circleOfCare": "Circle of Care",
	"pages.title.programs": "Programs",
	"pages.title.surveys": "Surveys",
	"pages.title.circles": "Circles",
	"pages.title.notifications": "Notifications",
	"pages.title.communities": "Communities",
	"pages.title.publicProfile": "Public Profile",
	"pages.title.healthboard": "Healthboard",
	"pages.title.home": "Home",
	"pages.title.homeTodos": "Home | Todo List",
	"pages.title.homeAppointments": "Home | Appointment List",
	"pages.title.dependentRole": "Add Dependent | Role",
	"pages.title.dependentPersonal": "Add Dependent | Personal Info",
	"pages.title.dependentGeneral": "Add Dependent | General Info",
	"pages.title.dependentDocuments": "Add Dependent | Documents",
	"pages.title.dependentRelation": "Add Dependent | Relationship",
	"pages.title.getCare.users": "Get Care | Who needs care?",
	"pages.title.getCare.organization": "Get Care | Choose Organization",
	"pages.title.getCare.visitType": "Get Care | Visit Type",
	"pages.title.getCare.publix": "Get Care | Publix",
	"pages.title.getCare.servces": "Get Care | Services",
	"pages.title.getCare.locations": "Get Care | Locations",
	"pages.title.getCare.consent": "Get Care | Sign Consent Form",
	"pages.title.getCare.pharm": "Get Care | Preferred Pharmacy",
	"pages.title.getCare.health": "Get Care | Health Information",
	"pages.title.getCare.payment": "Get Care | Payment",
	"pages.title.getCare.patientInfo": "Get Care | Patient Info",
	"pages.title.getCare.insurance": "Get Care | Insurance",
	"pages.title.getCare.documents": "Get Care | Documents",
	"pages.title.getCare.details": "Get Care | Visit Details",
	"pages.title.getCare.providers": "Get Care | Available Providers",
	"pages.title.getCare.timeSlots": "Get Care | Available Time Slots",
	"pages.title.getCare.providerInfo": "Get Care | Provider Details",
	"pages.title.getCare.overview": "Get Care | Appointment Overview",
	"pages.title.getCare.emergencyContact": "Get Care | Emergency Contact",
	"pages.title.getCare.guarantorInformation": "Get Care | Guarantor information",
	"pages.title.getCare.additionalInfo": "Get Care | Additional Information",
	"pages.title.visitDetails": "Visit Details",
	"pages.title.profile.surveys": "Profile | Surveys",
	"pages.title.profile.documents": "Profile | Documentation",
	"pages.title.profile.settings": "Profile | Settings",
	"pages.title.profile.payment": "Profile | Payment Methods",
	"pages.title.profile.support": "Profile | Support",
	"pages.title.profile.patientInfo": "Profile | Patient Info",
	"pages.title.profile.details": "Profile | Details",
	"common.blank": " ",
	"common.patient": "Patient",
	"common.settings": "Settings",
	"common.remove": "Remove",
	"common.apply": "Apply",
	"common.joinVisit": "Join Visit",
	"common.addPatient": "Add patient",
	"common.unassign": "Unassign",
	"common.assign": "Assign",
	"common.accept": "Accept",
	"common.decline": "Decline",
	"common.back": "Back",
	"common.cancel": "Cancel",
	"common.confirm": "Confirm",
	"common.save": "Save",
	"common.invite": "Send invitation",
	"common.send": "Send",
	"common.terms": "Terms and conditions",
	"common.termOfUse": "Terms of Use",
	"common.yes": "Yes",
	"common.gotIt": "Got it",
	"common.saveAnyway": "Save anyway",
	"common.ok": "Ok",
	"common.add": "Add",
	"common.no": "No",
	"common.preferNotToSay": "Prefer not to say",
	"common.close": "Close",
	"common.clear": "Clear",
	"common.tryAgain": "Try again",
	"common.collapse": "Collapse",
	"common.readMore": "Read more",
	"common.myMessages": "My Messages",
	"common.myCommunities": "My Communities",
	"common.myHealthboard": "My Healthboard",
	"common.discover": "Discover",
	"common.activities": "Activities",
	"common.reports": "Reports",
	"common.optional": "(optional)",
	"common.privacy": "Privacy Policy",
	"common.currentMedications": "Current medications",
	"common.from": "From",
	"common.to": "To",
	"common.notifications": "Notifications",
	"common.allow": "Allow",
	"common.deny": "Deny",
	"common.by": "by",
	"common.denied": "Denied",
	"common.verified": "Verified",
	"common.copy": "Copy",
	"common.likes": "Likes",
	"common.comments": "Comments",
	"common.resolve": "Resolve",
	"common.new": "New",
	"common.leave": "Leave",
	"common.emptySection": "Section is empty.",
	"common.next": "Next",
	"common.description": "Description",
	"common.complete": "Complete",
	"common.goBack": "Go back",
	"common.changeRole": "Change Role",
	"common.removeMember": "Remove member",
	"common.today": "Today",
	"common.confirmed": "Confirmed",
	"common.other": "Other",
	"common.searchByName": "Search by Name",
	"common.date": "Date",
	"common.phone": "Phone",
	"common.documents": "Documents",
	"common.my": "My",
	"common.pending": "Pending",
	"common.category": "Category",
	"common.subCategory": "Subcategory",
	"common.delete": "Delete",
	"common.hours": "Hours",
	"common.skip": "Skip",
	"common.ID": "ID",
	"common.resendCode": "Resend code",
	"common.resendInvite": "Resend Invite",
	"common.overlap": "Overlap",
	"common.seeDetails": "See details.",
	"common.hidden": "Hidden",
	"common.onlyVisibleToYou": "Only visible to you",
	"common.connect": "Connect",
	"common.join": "Join",
	"common.version": "Version",
	"common.program": "Program",
	"common.for": "for",
	"common.none": "None",
	"common.expired": "Expired",
	"common.moreInfo": "More info",
	"common.important": "Important",
	"common.changeTime": "Change time",
	"common.visit": "Visit",
	"common.call": "Call",
	"common.prescriptions": "Prescriptions",
	"common.showInactiveMedictions": "Show Inactive",
	"common.phoneNumber": "Phone Number",
	"common.urgentCareVisit": "Urgent Care Visit",
	"common.submit": "Submit",
	"common.selfPay": "Self-pay",
	"common.selectOption": "Select an option",
	"common.addInsurance": "Add insurance",
	"common.deleteInsurance": "Delete insurance",
	"common.startTyping": "Start typing",
	"common.myPcpNotListed": "My PCP isn't listed",
	"common.myEmployerNotListed": "Employer isn't listed",
	"common.expDate": "Exp Date",
	"common.saving": "Saving...",
	"common.seeLessDetails": "See less details",
	"common.seeMoreDetails": "See more details",
	"common.requiredInformationMissing": "Required information is missing",
	"menu.healthboard": "Healthboard",
	"menu.myCircles": "My Circles",
	"menu.communities": "Communities",
	"menu.dashboard": "Dashboard",
	"menu.messages": "Messaging",
	"menu.home": "Home",
	"messages.chat.enterUsernameOrName": "Enter the username or name of a user you’d like to begin a conversation with",
	"messages.chat.searchForUser": "Search for user or team you’d like to begin a conversation with.",
	"messages.chat.newChat": "New chat",
	"messages.chat.findAMember": "Find a member",
	"messages.chat.youAddedMembers": "You added {counter} {counter, plural, one {member} other {members}}",
	"messages.chat.counterMembers": "{counter} {counter, plural, one {member} other {members}}",
	"messages.chat.startANewConversationInTheContextOf": "Start a new conversation in the context of {user}",
	"messages.chat.startANewConversationInTheContextOfDesc": "People listed below are in the Circle of Care and you can add others not in Circles by searching",
	"messages.chat.startANewConversation": "Start a new conversation",
	"messages.chat.start": "Start",
	"messages.chat.noOneFound": "No one found",
	"messages.chat.empty.messages": "You have no messages",
	"messages.chat.empty.users": "No users to chat",
	"messages.chat.empty.channels": "No channels to connect",
	"messages.chat.searchAUser": "Search for a user...",
	"messages.chat.defaultUser": "ENTER THE USERNAME OR NAME OF A USER YOU’D LIKE TO ADD TO THE CHAT",
	"messages.userProfile.familyMembers": "Family members",
	"messages.userProfile.programServiceProviders": "Program/Service providers",
	"messages.userProfile.singleProvider": "Single care provider",
	"messages.userProfile.mainProvider": "Main care provider",
	"messages.userProfile.memberProviderCircle": "Member",
	"messages.titles.familyTitleWithCounter": "Family Circle ({counter})",
	"messages.titles.providerTitleWithCounter": "Provider Circle ({counter})",
	"messages.nav.tabs.patient": "General User",
	"messages.nav.tabs.provider": "Provider",
	"messages.filterOptions.allPatients": "All Patients",
	"messages.filterOptions.myPatients": "My Patients",
	"messages.statusFilterOptions.all": "All",
	"messages.statusFilterOptions.joined": "Joined",
	"messages.statusFilterOptions.notJoined": "Not Joined",
	"messages.patientNotJoined.message": "Patient has not joined yet.",
	"messages.patientOrGuardianNotJoined": "Patient or Guardian has not joined yet.",
	"messages.patientNotJoined.resend": "Resend an Invitation",
	"messages.patientNotJoined.invite": "Send an Invitation",
	"messages.patientNotJoined.inviteSent": "Invitation sent",
	"messages.patientNotJoined.checkContactInformationText": "Please confirm patient's contact details before sending invite",
	"messages.patientNotJoined.inviteTitle": "Invite Patient",
	"messages.patientNotJoined.errors.emailAlreadyTaken": "Email already used, please provide another",
	"messages.patientNotJoined.errors.emailInvalid": "Email is invalid, please provide another",
	"messages.patientNotJoined.errors.emailBlank": "Email can't be blank",
	"messages.patientNotJoined.errors.phoneNumberAlreadyTaken": "Phone number already used, please provide another",
	"messages.patientNotJoined.errors.phoneNumberBlank": "Phone number can't be blank",
	"messages.patientNotJoined.errors.phoneNumberInvalid": "Phone number is invalid",
	"messages.titles.accessLevel": "Access level",
	"messages.titles.accessLevelTooltip": "Temporary Access will be kept within current session only. Session timeout is 30 minutes since the last activity.",
	"messages.titles.reasonForAssignment": "Reason for assignment",
	"messages.titles.selectReasonForAssignment": "Select a reason for assignment",
	"messages.titles.practiceRemoved": "You can’t message because Practice has been removed",
	"messages.titles.practiceEmpty": "You can’t message because Practice has no assigned Providers",
	"messages.titles.archivedChat": "You can’t message because chat has been archived",
	"messages.titles.hasPractice": "You can’t message because Patient has been removed from Practice",
	"messages.call.missedCall": "Missed Call",
	"messages.call.outgoingCall": "Outgoing Call",
	"messages.call.declinedCall": "Declined Call",
	"messages.call.cancelledCall": "Canceled Call",
	"messages.call.incomingCall": "Incoming Call",
	"relationshipPriority.title": "Assign the relationship priority",
	"relationshipPriority.subtitle": "Select a relationship priority",
	"circles.circle": "Circle",
	"circles.circleOfCare": "Circle of Care",
	"circles.circle.typedCircle": "{type} circle",
	"circle.assigned": "Provider/team has been assigned successfully",
	"circle.unassigned": "Provider/team has been unassigned successfully",
	"circle.confirmUnassigned": "Sorry, but you have been unassigned from this patient and have no more permissions to access this page.",
	"circle.notInCircle": "Not in {contextUser}’s Provider Circle",
	"circles.empty": "You have no circles",
	"circles.empty.navigation": "No circles to browse",
	"circles.invites.cancelInvite": "Cancel invitation",
	"circles.invites.confirmCancel": "Yes, I'm sure",
	"circles.invites.declineCancel": "No",
	"circles.invites.inviteSent": "Invitation sent",
	"circles.invites.invitedCaregiver": "Caregiver (pending)",
	"circles.invites.roleChanged": "The role has been changed",
	"circles.invites.family.success": "Family member invitation has been sent",
	"circles.invites.caregiver.success": "Caregiver invitation has been sent",
	"circles.invites.common.success": "Your invitation has been sent",
	"circles.invites.provider.success": "Provider/team has been assigned successfully",
	"circles.invites.family.accept": "You've joined family circle",
	"circles.invites.family.decline": "You've declined family circle invitation",
	"circles.invites.caregiver.accept": "You've accepted caregiver role",
	"circles.invites.caregiver.decline": "You've declined caregiver role",
	"circles.invites.guardian.accept": "You've accepted guardian/proxy role",
	"circles.invites.guardian.decline": "You've declined guardian/proxy role",
	"circles.invites.provider.leave.success": "Provider/team has been unassigned successfully",
	"circles.provider.remove": "Provider was removed from your provider circle",
	"circles.provider.leave": "You left provider circle",
	"circles.provider.alreadyAssigned": "Patient already assigned",
	"circles.invites.caregiver.error": "Invited user is already a Caregiver of the Patient",
	"circles.invites.guardian.error": "Invited user is already a Guardian of this Patient",
	"circles.invites.member.error": "Invited user is already a Family member of this Patient",
	"circles.invites.cares.error": "Invited user already Cares for this Patient",
	"circles.invites.title": "Invite member",
	"circles.invites.subtitle": "by email or phone",
	"circles.invites.text.family": "has consented to invite you to their Family Circle. As a member of Family Circle you will receive access to personal health information and will be able to communicate with other members in the family circle and also with healthcare providers.",
	"circles.invites.text.provider": "has consented to invite you to their Provider Circle. As a member of Provider Circle you will receive access to personal health information and will be able to communicate with other members in the provider circle and also with family members.",
	"circles.invites.text.caregiver": "wants to assign you a Caregiver role. As a Caregiver you will be able to answer surveys within {patient}'s programs, edit the profile and use the app on behalf of {patient}.",
	"circles.invites.text.ProviderInvitesCaregiver": "has invited you to be the caregiver for {patientName} in {brandName}. As a Caregiver you will be able to answer surveys on behalf of {patientName} and use {brandName} on behalf of {patientName}. You consent to be Caregiver for {patientName}.",
	"circles.invites.text.guardian": "wants to assign you as a Guardian. As a Guardian, you will be able to respond to surveys, edit the patient's profile, and use the system on behalf of {patient} (Patient).",
	"circles.invites.makeInviteToFamilyText": "As a member of your Family Circle the family member you are inviting will see all your health information and will be able to communicate with your family and Provider Circle.",
	"circles.invites.makeInviteToFamilyCommon": "Inviting a family member to join this Family Circle allows them to view Health Information and communicate within the Circle of Care.",
	"circles.invites.makeInviteProviderText": "As a member of your Provider Circle the provider member you are inviting will receive access to personal health information and will be able to communicate with other members in the provider circle and also with family members.",
	"circles.invites.makeInviteCaregiverText": "A Caregiver is given access to answering surveys, editing a profile, and using the system on a patient's behalf.",
	"circles.invites.makeInviteGuardianText": "Guardian/proxy is able to respond surveys within of patient`s programs, edit patient`s profile, use the system on behalf of the patient and manage patient`s insurance information.",
	"circles.invites.makeAssignRoleDescription": "The role assigned to this user will determine their Privacy and Security Settings within the Circle of Care.",
	"circles.invites.makeChangeRoleDescription": "Changing the role for this user may alter their Privacy and Security Settings within the Circle of Care.",
	"circles.invites.pending": "pending invitations",
	"circles.invites.caregiver": "Caregiver is able to respond surveys within of Patient's programs, edit Patient's profile and use system on behalf of Patient.",
	"circles.invites.invitePerson": "Inviting a person to join this Family Circle allows them to view Health Information and communicate within the Circle of Care.",
	"circles.titles.invitations": "Invitations",
	"circles.titles.listCaregiver": "You are caregiver for",
	"circles.titles.guardianFor": "You are guardian for",
	"circles.titles.familyMemberingCircle": "Your family circles",
	"circles.titles.listFamilyCircleMember": "Family circles",
	"circles.titles.listProviderMember": "You are provider circle member",
	"circles.titles.familyCircle": "",
	"circles.titles.providerCircle": "Provider circles",
	"circles.titles.primaryProviderProfileTitle": "My provider circle",
	"circles.titles.primaryPatientProfileTitle": "My family circle",
	"circles.titles.caregiverRole": "Caregiver",
	"circles.titles.careProvider": "Care Provider",
	"circles.titles.removeRole": "Remove role",
	"circles.titles.provider.assign": "Assign new Provider or Team to the Circle",
	"circles.family.removeQuestion": "Are you sure you want to remove this member?",
	"circles.family.remove": "User was removed from your family circle",
	"circles.family.leave": "You left family circle",
	"circles.family.cancelInvite.title": "Are you sure you want to cancel invitation to the family circle?",
	"circles.family.cancelInvite.text": "You are about to cancel the invitation to the family circle sent on email {login}. Once you cancel it, this person won't be able to accept it and join your family circle.",
	"circles.caregiver.cancelInvite.title": "Are you sure you want to cancel invitation to be a caregiver?",
	"circles.caregiver.cancelInvite.text": "You are about to cancel invitation of your {role} to be a caregiver. Once you cancel it, this person won't be able to accept it and become a caregiver.",
	"circles.actions.leave": "Leave the circle",
	"circles.actions.leaveBtn": "Leave circle",
	"circles.actions.makeCaregiver": "Assign caregiver role",
	"circles.actions.removeCaregiver": "Remove caregiver role",
	"circles.actions.removeFromCircle": "Remove from circle",
	"circles.actions.inviteProvider": "Invite provider member",
	"circles.actions.inviteFamily": "Invite family member",
	"circles.actions.assignGuardian": "Assign guardian/proxy role",
	"circles.actions.removeGuardian": "Remove guardian/proxy role",
	"circles.actions.assignRole": "Assign Role",
	"circles.leave.family.title": "Are you sure you want to leave circle?",
	"circles.leave.family.body": "You are about to leave {patient} Family circle. Also once you leave the circle you will no longer have access to or be able to view the healthboard of {patient}.",
	"circles.leave.provider.title": "Are you sure you want to leave circle?",
	"circles.leave.provider.body": "You are about to leave {provider} Provider circle. Also once you leave the circle you will no longer have access to personal health information of {provider}.",
	"circles.leave.guardian.title": "You were the one who can manage the {patient} account. Are you sure you want to remove the role?",
	"circles.leave.guardian.body": "If you want to be a Guardian/Proxy again please ask the Provider to assign you.",
	"circles.roles.spouse": "Spouse",
	"circles.roles.daughter": "Daughter",
	"circles.roles.son": "Son",
	"circles.roles.sister": "Sister",
	"circles.roles.brother": "Brother",
	"circles.roles.mother": "Mother",
	"circles.roles.father": "Father",
	"circles.roles.granddaughter": "Granddaughter",
	"circles.roles.grandson": "Grandson",
	"circles.roles.grandmother": "Grandmother",
	"circles.roles.grandfather": "Grandfather",
	"circles.roles.partner": "Partner",
	"circles.roles.guardian": "Guardian",
	"circles.roles.relative": "Relative",
	"circles.roles.friend": "Friend",
	"circles.roles.power_of_attorney": "Power Of Attorney",
	"circles.roles.patient": "Patient",
	"circles.roles.caregiver": "Caregiver",
	"circles.roles.left_the_circle": "Left the Circle",
	"circles.roles.single_care_provider": "Single Care Provider",
	"circles.roles.family_member": "Family Member",
	"circles.roles.proxy": "Proxy",
	"circles.roles.parent": "Parent",
	"circles.roles.guardianProxy": "Guardian/Proxy role",
	"circles.roles.guardianProxyShort": "Guardian/Proxy",
	"circles.roles.none": "None",
	"circles.roles.description.family_member": "A Family Member is able to view your health information and communicate with the Family Members and Providers in your Circle of Care.",
	"circles.roles.description.caregiver": "A Caregiver is able to view your health information, communicate with the Circle of Care, answer surveys, schedule visits, and edit a Patient’s profile.",
	"circles.roles.description.guardian": "A Guardian is given full access to a Patient’s profile to act and manage the system on the Patient’s Behalf. This role requires proper legal documentation to be reviewed and verified.",
	"circles.roles.description.proxy": "A Guardian is given full access to a Patient’s profile to act and manage the system on the Patient’s Behalf. This role requires proper legal documentation to be reviewed and verified.",
	"circles.roles.description.parent": "A parent is given full access to a Patient’s profile to act and manage the system on the Patient’s behalf. Access levels change dependent on age according to Federal Regulations.",
	"circles.roles.description.patient": "A patient is given full access to their profile to act and manage the system. Patient have the ability to invite other members to access the system on their behalf.",
	"circles.addProviderReason.temporaryTitle": "Temporary Access",
	"circles.addProviderReason.permanentTitle": "Permanent Assignment",
	"circles.addProviderReason.temporary.emergencyAccess": "Emergency access",
	"circles.addProviderReason.temporary.temporarilyAssigned": "Temporarily assigned to patient",
	"circles.addProviderReason.temporary.patientConsultation": "Patient consultation",
	"circles.addProviderReason.permanent.underTreatment": "Current patient under treatment",
	"circles.addProviderReason.permanent.patientRequest": "Patient request",
	"communities.empty.navigation": "No communities to browse",
	"communities.empty": "You have no communities",
	"communities.empty.activities": "You have no activities",
	"communities.title.member": "My Communities",
	"communities.title.moderator": "I am Moderator",
	"communities.title.fromOrganization": "From my Organizations",
	"communities.title.otherCommunities": "Other communities",
	"communities.title.seeAll": "See all",
	"communities.title.posts": "posts",
	"communities.title.joinRequests": "Join Requests",
	"communities.title.invites": "Invites",
	"communities.title.share": "Share this community",
	"communities.title.join": "Join {brandName} right away",
	"communities.title.signUpToJoin": "Sign up to join this community",
	"communities.title.seeNewPosts": "See new posts",
	"communities.title.requested": "Requested",
	"community.type.public": "Public",
	"community.type.private": "Private",
	"community.type.global": "Global",
	"community.access.readOnly": "Read Only",
	"community.pinnedPost": "Pinned post",
	"community.access.withApproval": "Read, Comment & Post with approval",
	"community.access.readAndPost": "Read and post",
	"community.actions.createPost": "New post",
	"community.empty": "There's no such community",
	"community.description": "About",
	"community.posts": "Most recent posts",
	"community.posts.empty": "There are no posts yet",
	"community.posts.private": "This community is private",
	"community.posts.privateSubtitle": "{name} is where you can share your experiences",
	"community.members": "members",
	"community.membersList": "Members ({count})",
	"community.moderatorsList": "Moderators ({count})",
	"community.postUpdated": "updated",
	"community.communityName": "Community Name",
	"community.menu.report": "Report",
	"community.menu.leave": "Leave",
	"community.menu.leaveCommunity": "Leave community",
	"community.menu.invitePeople": "Invite People",
	"community.menu.invite": "Invite",
	"community.menu.inviteDefault": "SEARCH FOR USER OR TEAM YOU'D LIKE TO INVITE TO COMMUNITY",
	"community.menu.leaveMessage": "Are you sure you want to leave the community?",
	"community.menu.shareLink": "Invitation URL",
	"community.menu.removeMember": "Remove from community",
	"community.menu.removeMemberMessage": "Are you sure you want to remove the user?",
	"community.menu.removeMemberFromCommunity": "Remove a user from community",
	"community.menu.editCommunity": "Edit community",
	"community.menu.removeLastCommunityModerator": "Sorry, you are the only one moderator who can manage the community. Ask the organization admin to handle it.",
	"community.activity.total": "You have {posts} new post(s) and {comments} new comment(s)",
	"community.activity.posts": "You have {posts} new post(s)",
	"community.activity.comments": "You have {comments} new comment(s)",
	"community.activity.sentRequest": "Sent the request to join the {communityName} community",
	"community.activity.invite": "Invited you to join {communityName} community",
	"community.activity.fromOrganization": "From {organization}",
	"community.activity.requestAccepted": "Your join request to {communityName} has been accepted by moderator",
	"community.activity.requestDeclined": "Your join request to {communityName} has been declined",
	"community.activity.inviteAccepted": "Accepted your invite to {communityName}",
	"community.activity.inviteDeclined": "Declined your invite to {communityName}",
	"community.activity.postApproved": "Your post for {communityName} community has been approved",
	"community.activity.postDeclined": "Your post for {communityName} community has been declined",
	"community.activity.openPost": "Open the post",
	"community.activity.leave": "Leave community",
	"community.reports.unresolved": "Unresolved",
	"community.reports.resolved": "Resolved",
	"community.reports.reported": "reported this community",
	"reports.community.type": "community",
	"reports.comment.type": "comment",
	"reports.post.type": "post",
	"reports.status": "Status",
	"reports.type": "Type",
	"reports.reason": "Reason",
	"reports.seeDetails": "See details",
	"reports.time": "Time",
	"reports.details": "Report Details",
	"reports.emptyMessage": "No user reports at the moment ",
	"reports.history": "Actions history",
	"reports.history.messageSent": "Message sent to the originator",
	"reports.history.wasDeleted": "was deleted",
	"reports.history.originatorRemoved": "The originator is removed from the community",
	"reports.community.info": "{user} reported this community",
	"reports.comment.info": "{user}'s comment from {community} was reported",
	"reports.post.info": "{user}'s post from {community} was reported",
	"post.title": "Post comments",
	"post.back": "Back to posts list",
	"post.comments": "Comments",
	"post.comments.add": "Add comment",
	"post.actions.createComment": "Post comment",
	"post.actions.reply": "Reply",
	"post.actions.discardPost": "Discard Post",
	"post.comment.description": "commented the post",
	"post.replies": "replies",
	"post.reply.description": "replied to {name}'s comment",
	"post.reply.placeholder": "Reply to the comment...",
	"post.comments.empty": "There are no comments yet",
	"community.newPost.title": "New post to {name} community",
	"community.newPost.edit.title": "Edit post in {name} community",
	"community.newPost.caption": "Caption",
	"community.newPost.attachImage": "Attach Image",
	"community.newPost.attachURL": "Attach URL",
	"community.newPost.addPost": "Add Post",
	"community.newPost.editPost": "Edit Post",
	"community.newPost.fileError": "Only images under {size}mb are allowed.",
	"community.newPost.urlError": "This link is not valid",
	"community.newPost.noPreview": "No Preview",
	"community.newPost.enterUrl": "Enter URL here...",
	"community.newPost.addPhoto": "Add photo",
	"community.newPost.maxAttachmentNumber": "You can only upload 10 files at the same time",
	"community.newPost.allowedFormatError": "Invalid file format. You can only upload jpg, jpeg and jpeg files.",
	"community.newPost.cancelPost": "All info will be removed. Are you sure? ",
	"community.newPost.sendForApproval": "Send for approval",
	"community.newPost.needsApproval": "In this community, publications must be approved by a moderator. ",
	"community.newPost.notification": "We will notify you when the moderator finishes reviewing your post",
	"community.postMenu.editPost": "Edit Post",
	"community.postMenu.deletePost": "Delete Post",
	"community.postMenu.confirmDeleteMessage": "Are you sure you want to delete this post? This cannot be undone.",
	"community.postMenu.report": "Report",
	"community.commentMenu.editComment": "Edit Comment",
	"community.commentMenu.deleteComment": "Delete Comment",
	"community.commentMenu.confirmDeleteComment": "Are you sure you want to delete this comment? This cannot be undone.",
	"community.commentMenu.report": "Report",
	"community.commentMenu.shareLink": "Invitation URL",
	"community.comments.commentWasDeleted": "Comment was deleted",
	"community.comments.commentWasDeletedByModerator": "Comment was deleted by moderator",
	"community.roles.moderator": "Moderator",
	"community.roles.member": "Member",
	"community.logo.cropTitle": "Update logo",
	"community.banner.cropTitle": "Update banner",
	"community.banner.cropTip": "1:4 ratio recommended.",
	"community.banner.removeTitle": "Are you sure you want to remove banner?",
	"community.logo.removeTitle": "Are you sure you want to remove this logo?",
	"profile.fieldSet.empty": "Section is empty. Edit section to add information.",
	"profiles.updated": "Profile has been updated",
	"settings.updated": "Settings has been updated",
	"profile.employee.workingHours.startTime.error": "The time of a start should be earlier then end time",
	"profile.employee.workingHours.endTime.error": "The time of a end should be later then start time",
	"programs.title": "Programs",
	"programs.emptyState": "is not assigned to any Program yet",
	"programs.invitation.emptyState": "There are no available Programs for the",
	"programs.invitation.addPatient": "Add Patient to a Program",
	"programs.invitation.invitationText": "invites you to join the Program/Service",
	"programs.invitation.title": "Program/Service Invitations for {user}",
	"programs.invitation.empty": "You have no program/service invitations",
	"programs.invitation.success": "Patient is successfully added to the Programs",
	"programs.actions.request": "Program/Service Invitations",
	"programs.actions.title": "Program/Service Details for {user}",
	"programs.actions.followup": "Visit followup for {user}",
	"programs.actions.subtitle": "About the program/service",
	"programs.actions.showMore": "Read More",
	"programs.actions.showLess": "Read Less",
	"programs.actions.more": "More",
	"programs.actions.leave": "Leave Program/Service",
	"programs.actions.aboutProgram": "About the program",
	"programs.remove.confirmRemove": "Are you sure you want to remove {patientName} from the {program}?",
	"programs.remove.success": "Patient has been successfully removed from the Program",
	"programs.remove.title": "Remove Patient from the Program",
	"programs.remove.subtitle": "Remove from Program",
	"programs.remove.message": "You left the program",
	"programs.remove.message.ar": "{dependentName} left the program",
	"programs.tabs.active": "Active",
	"programs.tabs.invites": "Invites",
	"programs.tabs.history": "History",
	"programs.tabs.invites.placeholder": "{name} has no invites",
	"programs.tabs.active.placeholder": "{name} has no active programs",
	"programs.tabs.history.placeholder": "{name} has no programs history",
	"helpCenter.support": "Support",
	"surveys.noUpcomingSurveys": "You have no upcoming surveys",
	"surveys.noSurveysResults": "There are no results to display",
	"surveys.sent": "Survey has been sent",
	"surveys.answer": "Survey has been answered",
	"surveys.completion": "Survey has been completed",
	"surveys.actions.answer": "Answer",
	"surveys.actions.save": "Save draft",
	"surveys.actions.proceed": "Proceed",
	"surveys.actions.general": "Service Satisfaction Info",
	"surveys.actions.review": "Review",
	"surveys.actions.submit": "Submit answers",
	"surveys.actions.submitOne": "Submit answer",
	"surveys.actions.upcoming": "Upcoming Surveys",
	"surveys.actions.upcomingTitle": "Upcoming",
	"surveys.actions.resultsTitle": "Results",
	"surveys.actions.upcomingHeading": "Upcoming Surveys for {user}",
	"surveys.actions.exportToPDF": "Export to PDF",
	"surveys.sendSurvey.noSurveys": "There is no surveys to send",
	"surveys.title": "Surveys",
	"surveys.title.data": "Data",
	"surveys.countSurveys": "{count} surveys",
	"surveys.results": "Survey Results",
	"surveys.single": "Survey",
	"surveys.totalScore": "Total Score:",
	"surveys.selectedChatDesc": "The survey will be available to all members of selected chat",
	"surveys.answeredBy": "Answered by",
	"surveys.answerForm": "Form has been answered",
	"surveys.noAvailableForms": "There is no available forms",
	"surveys.inProgress": "In progress",
	"surveys.inProgressMessage": "Someone has started this task already. When it’s done, you’ll see it in the Results section.",
	"surveys.isStarted": "Is started",
	"surveys.isStartedMessage": "Someone else has started working on this task. When it’s completed, you can view it in the Results section.",
	"surveys.program": "program",
	"surveys.scale.description": "Increasing severity:",
	"surveys.appointmentConsent.accept": "Do you accept",
	"surveys.preVisit.serviceType": "Service type",
	"surveys.preVisit.visitType": "Visit type",
	"surveys.preVisit.preVisitForm": "Pre-visit Form",
	"surveys.method.program": "Assigned via {name} Program",
	"surveys.method.provider": "Assigned by {name}, Provider",
	"surveys.method.system": "Assigned by System",
	"surveys.method.employer": "Assigned by Employer",
	"surveys.method.referralForm": "Referral form",
	"surveys.assignedBy": "Assigned by",
	"surveys.desc.program": "{name} Program",
	"surveys.desc.provider": "{name}, Provider",
	"surveys.desc.system": "system",
	"surveys.message.respond": "Please respond to",
	"surveys.formResults": "Form Results",
	"carePlan.assignedBy.provider": "Assigned Care Plan To Do, assigned by {displayableName} (Provider)",
	"profile.actions.cancel": "Discard",
	"profile.actions.details": "See detailed profile",
	"profile.actions.submit": "Save changes",
	"profile.actions.provider": "Provider",
	"profile.actions.patient": "Patient was added",
	"profile.actions.back": "Patient's healthboard",
	"profile.avatar.remove": "Remove",
	"profile.avatar.upload": "Upload photo",
	"profile.avatar.update": "Update photo",
	"profile.insurance": "Insurance",
	"profile.insurance.additional": "Additional insurance",
	"profile.insurance.skipInsurance": "Skip insurance",
	"profile.tabType.team": "Team profile",
	"profile.tabType.patient": "User profile",
	"profile.tabType.provider": "Provider profile",
	"profile.tabType.detailedProfile": "Detailed profile",
	"profile.tabType.surveys": "General surveys",
	"profile.section.emergencyContact": "Emergency contact",
	"profile.section.guarantorInformation": "Guarantor information",
	"profile.section.profileInfo": "Profile Info",
	"profile.section.general": "General information",
	"profile.section.personal": "Personal information",
	"profile.section.contacts": "Contact/login information",
	"profile.section.health": "Health information",
	"profile.section.insurance": "Insurance Details",
	"profile.section.insurance.empty": "No Insurance",
	"profile.section.insuranceAndId": "Insurance and ID details",
	"profile.section.prof": "professional information",
	"profile.section.mrns": "Medical Record Numbers",
	"profile.section.empinf": "Employment information",
	"profile.section.affiliations": "Affiliations",
	"profile.section.address": "Home Address",
	"profile.section.notificationSettings": "Notification Settings",
	"profile.section.privacySettings": "Privacy Settings",
	"profile.section.languageSettings": "Language Settings",
	"profile.section.workingHours": "Working hours",
	"profile.section.mfaSettings": "Multi-Factor Authentication",
	"profile.section.mfaSettings.label.active": "Active",
	"profile.section.mfaSettings.label.inActive": "Inactive",
	"profile.section.mfaSettings.label.helperText": "A verification code will be sent to authenticate the user",
	"profile.section.mfaSettings.button.activate": "Activate Multi-Factor Authentication",
	"profile.section.mfaSettings.button.inActivate": "Inactivate Multi-Factor Authentication",
	"profile.section.mfaSettings.confirmModal.inActivate.title": "Are you sure you want to inactivate Multi-Factor Authentication?",
	"profile.section.mfaSettings.confirmModal.inActivate.button": "Inactivate",
	"profile.section.deviceSetup": "Device Setup",
	"profile.section.deviceSetup.addDeviceAccount": "Add New Device Account",
	"profile.section.deviceSetup.noAccount": "No Accounts Connected",
	"profile.section.deviceSetup.addAccountDescription": " (Tap Add New Device Account to Set up a device and upload your Health data)",
	"profile.section.deviceSetup.removeAccount": "Remove Account",
	"profile.section.deviceSetup.detailsAccount": "{name} Account",
	"profile.section.deviceSetup.noDevices": "No Connected Devices",
	"profile.section.deviceSetup.synced": "Synced ",
	"profile.section.deviceSetup.removeConfirmation": "Are you sure you want to remove account?",
	"profile.section.deviceSetup.chooseDeviceAccount": "Choose Device Account",
	"profile.section.deviceSetup.noPermission": "No access to {type} account",
	"profile.section.deviceSetup.noPermissionAnnotation": " (Please allow access during login or add another account to set up devices.)",
	"profile.section.deviceSetup.accountIsAdded": "Account is added",
	"profile.section.deviceSetup.noPermissionNotification": "No access to account",
	"profile.section.deviceSetup.manageDataFromMobile": "Apple Health can be connected and managed from iOS mobile app.",
	"profile.section.deviceSetup.appleHealth": "Apple Health",
	"profile.section.deviceSetup.connectToGoogleFit": "Connect to Google Fit",
	"profile.section.deviceSetup.googleFit.description": "Using “{brandName}” with Google Fit on your device empowers you to better manage your health. “{brandName}” will read and store your data so that you, your family, and your Care Team can view it at any time.",
	"profile.section.deviceSetup.googleFit.signIn": "Sign in with Google",
	"profile.section.deleteAccount.title": "Delete Account",
	"profile.section.deleteAccount.description": "Please send a request to our Support Team in order to delete account.",
	"profile.section.unitsSettings.title": "Units",
	"profile.section.unitsSettings.weight": "Weight",
	"profile.section.unitsSettings.weight.metric.pounds": "lbs",
	"profile.section.unitsSettings.weight.metric.kilograms": "kg",
	"profile.section.unitsSettings.height": "Height",
	"profile.section.unitsSettings.height.metric.meters": "cm",
	"profile.section.unitsSettings.height.metric.feet_and_inches": "ft",
	"profile.section.unitsSettings.temperature": "Body temperature",
	"profile.section.unitsSettings.temperature.metric.celsius": "°C",
	"profile.section.unitsSettings.temperature.metric.fahrenheit": "°F",
	"profile.section.unitsSettings.glucose": "Blood glucose",
	"profile.section.unitsSettings.glucose.metric.mmol/L": "mmol/L",
	"profile.section.unitsSettings.glucose.metric.mg/dL": "mg/dL",
	"profile.section.insurance.healthPlan": "Health Plan",
	"profile.section.insurance.verificationDate": "Eligibility Verification Date",
	"profile.error.viewDetailedProfile": "You should be a member of Patient` Provider circle to view detailed profile.",
	"mfa.dialog.title": "Multi-Factor Authentication",
	"mfa.dialog.button.verify": "Verify",
	"mfa.dialog.error.message": "The code entered is invalid",
	"mfa.dialog.input.label": "Confirm code",
	"mfa.dialog.phoneConfirmation": "A confirmation code was sent to your phone {phone}",
	"mfa.dialog.emailConfirmation": "A confirmation code was sent to your email {email}",
	"mfa.dialog.phoneAndEmailConfirmation": "A confirmation code was sent to your phone or your email",
	"mfa.dialog.constPhoneAndEmailConfirmation": "A confirmation code was sent to your phone {phone} and your email {email}",
	"mfa.dialog.resendCode": "Wait {counter} sec.",
	"mfa.dialog.activate.bodyText": "A verification code will be sent to authenticate the user.",
	"mfa.dialog.activate.button": "Activate",
	"mfa.dialog.advert.title": "Protect your account by using Multi-Factor Authentication",
	"mfa.dialog.advert.contentText": "A verification code will be sent to authenticate the user.",
	"otp.dialog.title": "One-time Passcode Authentication",
	"otp.dialog.contentText": "Enter your email or phone number and we'll send you back one-time passcode authentication instruction. Please use the email/phone number where you received your invitation or placed in Contact info.",
	"otp.dialog.getPasscode": "Get passcode",
	"otp.dialog.error.tooManyRequests": "Too many attempts, try again later",
	"fields.dob": "Date of Birth",
	"fields.patientType": "Patient Type",
	"fields.email": "Email",
	"fields.emailAddress": "Email address",
	"fields.address1": "Address 1",
	"fields.address2": "Address 2",
	"fields.city": "City",
	"fields.state": "State",
	"fields.postalCode": "Postal / ZIP code",
	"fields.gender": "Gender",
	"fields.firstname": "First Name",
	"fields.lastname": "Last Name",
	"fields.password": "Password",
	"fields.username": "Nickname",
	"fields.login": "Login",
	"fields.login.placeholder": "Email, Phone Number or Username",
	"fields.phoneNumber": "Phone Number",
	"fields.reasonType": "Appointment Type",
	"fields.reasonType.placeholder": "Appointment Type",
	"fields.reasonVisit": "Reason for Visit",
	"fields.reasonNote": "Reason for Visit",
	"fields.reasonNote.placeholder": "Add reason for visit",
	"fields.chatName": "Chat name",
	"fields.chatName.placeholder": "Enter chat name",
	"fields.insurance.memberId": "Member ID",
	"fields.insurance.groupNumber": "Group Number",
	"fields.insurance.primarySubscriber": "{name} is the Primary Subscriber",
	"fields.insurance.mainPrimarySubscriber": "I am the Primary Subscriber",
	"fields.insurance.primarySubscriber.title": "Primary Subscriber Details",
	"fields.insurance.search.emptyState": "No results found",
	"fields.insurance.haveNotInsurance": "I don't have insurance",
	"fields.insurance.patientHaveNotInsurance": "{name} doesn't have insurance",
	"fields.emailPhoneNumber": "Email or Phone number",
	"fields.pcpName": "Enter your PCP's name",
	"fields.pcpName.selectPcpName": "Select your PCP's name",
	"fields.doYouConsiderUsAsYourPCP": "Do you consider us as your PCP?",
	"fields.enterEmployerName": "Enter employer name",
	"profile.loadingPopup": "Scanning your insurance details,\nplease wait...",
	"profile.insuranceCard.uploading": "Uploading...",
	"profile.fields.unit": "Units",
	"profile.fields.weight": "Weight",
	"profile.fields.height": "Height",
	"profile.fields.workingHours.startTime": "Start time",
	"profile.fields.workingHours.endTime": "End time",
	"profile.fields.workingHours.timeZone": "Time zone",
	"profile.fields.description": "Description",
	"profile.fields.relationship": "Relationship",
	"profile.fields.relationship.placeholder": "Select relationship",
	"profile.fields.role": "Role",
	"profile.fields.role.placeholder": "Select role",
	"profile.fields.relation": "Relation",
	"profile.fields.bio": "Bio",
	"profile.fields.location": "Location",
	"profile.fields.phones": "Phones",
	"profile.fields.healthInterests": "Health interests",
	"profile.fields.name": "Name",
	"profile.fields.firstName": "First Name",
	"profile.fields.middleName": "Middle Name",
	"profile.fields.lastName": "Last Name",
	"profile.fields.nameSuffix": "Name suffix",
	"profile.fields.gender": "Gender",
	"profile.fields.genderIdentity": "Gender identity",
	"profile.fields.dob": "Date of birth",
	"profile.fields.age": "Age",
	"profile.fields.race": "Race",
	"profile.fields.mStatus": "Marital status",
	"profile.fields.ethnic": "Ethnicity",
	"profile.fields.language": "Language",
	"profile.fields.prefLanguage": "Preferred language",
	"profile.fields.languages": "Languages",
	"profile.fields.religion": "Religion",
	"profile.fields.email": "Email",
	"profile.fields.homeAddress": "Home Address",
	"profile.fields.address1": "Address 1",
	"profile.fields.address2": "Address 2",
	"profile.fields.address2Optional": "Address 2 (Optional)",
	"profile.fields.city": "City",
	"profile.fields.state": "State / Province",
	"profile.fields.onlyState": "State",
	"profile.fields.postalCode": "Postal / ZIP code",
	"profile.fields.isHomeLocationDifferent": "My current location is different from their home address",
	"profile.fields.country": "Country",
	"profile.fields.homePhone": "Home phone number",
	"profile.fields.mobilePhone": "Mobile phone number",
	"profile.fields.phone": "Phone number",
	"profile.fields.localUid": "Medical Record Number (MRN)",
	"profile.fields.allergies": "Allergies",
	"profile.fields.medicationAllergies": "Medications allergies",
	"profile.fields.healthConditions": "Health conditions",
	"profile.fields.doYouHavePCP": "Do you have a primary care provider (PCP)?",
	"profile.fields.helpFindProvider": "Can we help you find primary care provider?",
	"profile.fields.medicine": "Medications",
	"profile.fields.healthGoals": "Health Goals",
	"profile.fields.mrns": "Medical Record Numbers",
	"profile.fields.localUidProvider": "Provider ID",
	"profile.fields.npi": "Provider NPI",
	"profile.fields.title": "Title",
	"profile.fields.specialty": "Speciality",
	"profile.fields.primaryPracticeAddress": "Primary Practice Address",
	"profile.fields.primaryPracticeAddress1": "Primary Practice Address 1",
	"profile.fields.primaryPracticeAddress2": "Primary Practice Address 2",
	"profile.fields.primaryPracticeCity": "Primary Practice City",
	"profile.fields.primaryPracticeState": "Primary Practice State",
	"profile.fields.primaryPracticeCountry": "Primary Practice Country",
	"profile.fields.officePhone": "Office Phone Number",
	"profile.fields.username": "Username",
	"profile.fields.username.hint": "Used for account Sign In",
	"profile.fields.aliasName": "Alias",
	"profile.fields.aliasName.hint": "Alias is used as community nickname",
	"profile.fields.phoneNumber": "Mobile Phone",
	"profile.fields.day": "Day",
	"profile.fields.year": "Year",
	"profile.fields.month": "Month",
	"profile.fields.organizations": "Organizations",
	"profile.fields.employers": "Employers",
	"profile.fields.ssn": "SSN",
	"profile.fields.educationLevel": "Highest level of education",
	"profile.fields.veteranStatus": "Veteran status",
	"profile.fields.citizenship": "Country of citizenship",
	"profile.fields.ssnLong": "Social Security Number (SSN)",
	"profile.fields.ssnPlaceHolder": "Social Security Number",
	"profile.fields.ssnDescription": "Social Security Number should have full 9 digits (e.g. 123456789) or last 4 digits (e.g. 6789)",
	"profile.fields.emailOrPhone": "Email or Phone",
	"profile.fields.insuranceCard": "Insurance card",
	"profile.fields.driverLicense": "Patient/Guardian ID",
	"profile.fields.removeItem": "This item won`t be able to select any more. Are you sure you want to remove it?",
	"profile.fields.ssnFull": "Social Security Number (SSN)",
	"profile.fields.mobilePhone.validation.short": "Phone is too short",
	"profile.fields.mobilePhone.validation.long": "Phone is too long",
	"profile.edit.emailConfirmationTitle": "Confirm contact information",
	"profile.edit.emailConfirmationText": "A verification email has been sent to {email}. The old email will continue to be used until you verify the new one.",
	"profile.edit.confirmCode": "Confirm code",
	"profile.edit.invalidCode": "You've entered invalid code",
	"profile.edit.phoneConfirmationText": "To start using the new mobile phone number it will need to be verified. We have sent an SMS with a confirmation code to {phone}. Please enter this code below.",
	"profile.notificationSettings.label": "Notify by {type} ({value})",
	"profile.notificationSettings.labels.email": "email",
	"profile.notificationSettings.labels.sms": "SMS",
	"profile.privacySettings.labels.nickname": "Use my nickname",
	"profile.privacySettings.labels.nicknameExtra": "(Your real name and profile photo will be hidden except from your Circle of Care)",
	"profile.list.gender.M": "Male",
	"profile.list.gender.F": "Female",
	"profile.list.gender.O": "Other",
	"profile.list.gender.U": "Unknown/Prefer not to say",
	"profile.list.marital.S": "Single",
	"profile.list.marital.M": "Married",
	"profile.list.marital.O": "Other",
	"profile.list.marital.U": "Unknown",
	"profile.list.marital.W": "Widowed",
	"profile.list.marital.D": "Divorced",
	"chat.common.removeFromChat": "Remove from chat",
	"chat.actions.downloadAttachment": "Download attachment",
	"chat.actions.editMessage": "Edit message",
	"chat.actions.deleteMessage": "Delete message",
	"chat.actions.confirmDeleteMessage": "Are you sure you want to delete this message? This cannot be undone.",
	"chat.actions.confirmLeaveChat": "Are you sure you want to leave this chat?",
	"chat.actions.reply": "Reply",
	"chat.actions.blockMessaging": "Block Messaging",
	"chat.actions.unblockMessaging": "Unblock Messaging",
	"chat.actions.blockForMe": "for me",
	"chat.actions.blockForDependent": "for dependent",
	"chat.actions.unblockUser": "Unblock User",
	"chat.actions.leaveChat": "Leave Chat",
	"chat.actions.sendMessage": "Send Message",
	"chat.titles.uploadingFile": "You are uploading a file {name}",
	"chat.titles.generalChatTab": "All Members",
	"chat.titles.familyChatTab": "Family Only",
	"chat.titles.customChannel": "Custom channel",
	"chat.titles.providersChatTab": "Providers Only",
	"chat.titles.activitiesChatTab": "To do",
	"chat.titles.notificationsChatTab": "Notifications/Alerts",
	"chat.titles.healthAlert": "Health Alert",
	"chat.titles.providerAssignment": "Provider Assignment",
	"chat.titles.providerRemoved": "Provider Unassigned",
	"chat.titles.memberAssignment": "Member Assignment",
	"chat.titles.notification": "Notification",
	"chat.titles.surveyReminder": "Reminder",
	"chat.titles.addedAttachment": "added an attachment",
	"chat.titles.provider": "Provider",
	"chat.titles.providers": "Providers",
	"chat.titles.family": "Family",
	"chat.title.chatInContextOf": "Chat in context of",
	"chat.title.inContextOf": "In context of",
	"chat.title.conversationInfo": "Conversation Info",
	"chat.title.chatName": "Chat Name",
	"chat.title.userBlocked": "You can’t message this contact because you’ve been blocked",
	"chat.title.newChatError": "You do not have permission to create this chat",
	"chat.title.blockedUserError": "Sorry, you can’t block this user",
	"chat.title.membersCounter": "{counter} members",
	"chat.title.chatDetails": "Chat details",
	"chat.title.editChatName": "Edit Chat Name",
	"chat.title.disclaimerInforming": "Send a non-urgent message to your care team. If this is a medical emergency, call 911.",
	"chat.placeholders.messageTo": "Message To",
	"chat.placeholders.default": "Type a message",
	"chat.placeholders.surveyExpired": "This survey expired",
	"chat.notifications.patientAssignedToProgram": "{providerName} from {organizationName} has enrolled {patientName} into the {programName} program/service",
	"chat.notifications.patientRemovedFromProgram": "{patientName} has been removed from the {programName} program/service",
	"chat.sorting.byUnread": "By Number of Unread",
	"chat.sorting.byLastMessage": "By Most Recent",
	"chat.errors.tooLong": "Maximum {length} symbols",
	"chat.errors.minLength": "Minimum {length} symbols",
	"chat.errors.maxAttachmentSize": "Max size 50Mb",
	"chat.errors.maxAttachmentSizeNextPart": "{files} is/are too large",
	"chat.errors.notAllowedFormat": "You can only upload jpg, png, pdf, docx, xlsx, pptx, rtf, txt, xml, mov, mp4 and vcf files",
	"chat.errors.uploadError": "Error occured during file upload. Please try again",
	"chat.errors.maxAttachmentNumber": "You can only upload 20 files at the same time",
	"chat.errors.invalidName": "Name is invalid",
	"chat.moreAttachments.sendSurvey": "Send Survey",
	"chat.moreAttachments.answerForm": "Answer Form",
	"chat.moreAttachments.attachFile": "Attach File",
	"chat.notification.newMessage": "new message",
	"auth.accessDenied.text": "Sorry, but you have no permissions to access this page.",
	"auth.createPassword.text": "Please enter your new password",
	"auth.expiredToken.text": "Sign up link expires after 7 days, and can only be used once.",
	"auth.expiredConfirmation.text": "Confirmation link expires after 7 days, and can only be used once.",
	"auth.expiredLink.text": "Your invitation link is invalid. If you completed the invitation process, go to {link} to login. If you need a new invitation, contact the person who sent you this invitation",
	"auth.expiredLinkDefault.text": "This link is expired.\nThe file you are trying to access is no longer available.\nAsk the owner to send it again.",
	"auth.recoverConfirm.email.title": "We've sent you an email with instructions to",
	"auth.recoverConfirm.email.confirmText": "Please check your email.",
	"auth.recoverConfirm.phone.title": "We've sent you a message with instructions to",
	"auth.recoverConfirm.phone.confirmText": "Please check your phone.",
	"auth.recoverPassword.textTitle": "Enter your email and we'll send you back password recovery instructions. Please use the email/phone number where you received your invitation or placed in Contact info.",
	"auth.recoverPassword.textLink": "Forgot password?",
	"auth.recoverPassword.primaryContacts.textTitle": "Enter your username, and we'll send password recovery instructions to your email or phone number associated with your account.",
	"auth.recoverPassword.primaryContacts.username": "Username",
	"auth.haveAccount.text": "First time user?",
	"auth.userNotFound.text": "The user with this email/phone does not exist",
	"auth.signup.title": "Don't have an account?",
	"auth.signup.textLink": "Sign up for {brandName}",
	"auth.signup.matchPassword": "Password and confirm password do not match",
	"auth.signup.confirmationPassword": "Confirm password",
	"auth.signup.setNewPassword": "Set new password",
	"auth.signup.newPassword": "New password",
	"auth.signup.text.emailPhone": "The email/phone number below is your login ID.",
	"auth.signup.text.email": "The email below is your login ID.",
	"auth.signup.text.username": "Username is used for account Sign In",
	"auth.signup.popover.title": "Username requirements:",
	"auth.signup.popover.li1": "use letters, numbers, or (. - _)",
	"auth.signup.popover.li2": "(+) and (@) allowed only once",
	"auth.signup.popover.li3": "no spaces",
	"auth.signup.text.phone": "The phone number below is your login ID.",
	"auth.tnc.title": "I have read and accept",
	"auth.tnc.textLink": "Terms and Conditions",
	"auth.logout.text": "Logout",
	"auth.signup.invitationLinkDesc": "You’ll receive an invitation link on your email or phone.",
	"auth.signup.personalInfoDesc": "Please review the data below to complete your registration.",
	"auth.signup.azure.description": "The e-mail/phone number below is your login ID.",
	"auth.signup.sentEmailVerification": "Verification link has been sent. Check your email please",
	"auth.signup.sentPhoneVerification": "Verification link has been sent. Check your phone please",
	"auth.signup.registrationInvitation": "Your invitation has been sent. Check your phone or email please",
	"auth.expire.multipleDevice": "Your’ve signed in to another device. You can use your account only at one device at a time",
	"auth.expire.expiredSession": "Your session has expired. \nPlease sign in again.",
	"auth.changePassword.text": "Your logged in with a temporary \npassword. To finish logging in, Please \ncreate new password.",
	"auth.login.text": "If you have an account, please \nenter the email, phone number or \nusername you previously provided. ",
	"auth.login.flagler.text": "Enter the email or phone number you previously used to set up your account.",
	"auth.login.flagler.subDescription": "You can also download the Flagler Health+ Anywhere app on your smart phone or tablet.",
	"auth.login.flagler.description": "Log in to Flagler Health+ Anywhere to schedule an appointment, view your health information and more.",
	"auth.nextStep": "Next Step",
	"auth.next": "Next",
	"auth.info.inviteEmailNotConfirmed": "You’ve already been invited to {brandName} \n Health App via this email address. \n \nPlease check your inbox and follow the \n link to complete your registration.",
	"auth.info.invitePhoneNotConfirmed": "You’ve already been invited to {brandName} \n Health App via this phone number. \n \nPlease check your SMS inbox and follow the \n link to complete your registration.",
	"auth.info.title.invitePhoneNotConfirmed": "Check your SMS inbox \nfor an invitation",
	"auth.info.title.inviteEmailNotConfirmed": "Check your email \nfor an invitation",
	"auth.info.inviteExpired": "The invitation that was sent to your email has \nexpired. Please ask your provider to invite you again.",
	"auth.info.inviteNotConfirmed": "An invitation was sent to your email. \nPlease accept the invitation and register.",
	"auth.info.signUpInviteNotConfirmed": "Your invitation has been sent. Check your phone or email please.",
	"auth.description": "Login, as Phone number should contain '+' and your country code, for example: +1234567890",
	"auth.browser.notSupport": "Your browser is not supported",
	"auth.browser.newVersion": "Please try a latest version of Google Chrome, or other modern browser",
	"auth.browser.getChrome": "Get Google Chrome",
	"auth.work-school.account": "to use Work/School account",
	"auth.forCommunityCollege": "for St. Louis Community College",
	"auth.otherLoginOptions": "Other login options",
	"auth.errors.notFound": "User Login not found. Please make sure you are using the email you have registered with.",
	"auth.errors.notConfirmed": "Your email is not confirmed. Please, check your inbox to confirm and complete registration.",
	"auth.errors.userDisabled": "An active user account was not found. Please contact support.",
	"auth.errors.gotIt": "Got it!",
	"auth.poweredByHealthfully.label": "Powered by Healthfully",
	"auth.sendOtp.title": "Send one-time passcode",
	"auth.sendOtp.inviteNotConfirmed": "An invitation was sent to your email. \n Please accept the invitation and login.",
	"auth.signup.description": "Your logged in with a temporary\n password. To finish logging in, Please\n create new password.",
	"errors.common": "Something went wrong...",
	"errors.commonErrorOccured": "An error occured, please try again later",
	"errors.emailError": "Enter valid email address",
	"errors.emailErrorDesription": "Login {error}",
	"errors.emailAndPhoneErrorDescription": "Entered Email or Phone is invalid",
	"errors.invalidDateOfBirth": "Invalid date of birth",
	"errors.login.unauthorized": "The information you entered doesn’t match our records. Please double-check and try again.",
	"errors.login.notFound": "We are unable to locate a registered account with that email/phone number.",
	"errors.login.incorrect": "Incorrect login. Please, try again.",
	"errors.login.registrationNotFinished": "You are not registered yet. Please, check your E-mail/SMS inbox to complete registration first.",
	"errors.login.authenticationLockout": "Authentication is under temporary lockout for this account due to too many failed login attempts. You can login again in 15 mins",
	"errors.nameLength": "First and Last Name should contain up to 40 symbols",
	"errors.requiredFields": "All fields are required",
	"errors.tnc": "Please confirm that you have read and accept the Privacy Policy and Terms and Conditions",
	"errors.cannotAcceptInvite": "You need to have patient profile to accept invitations to family circles",
	"errors.nicknameContainsCommercialAt": "Nickname should not contain @ symbol",
	"errors.password": "Password cannot be blank or contain only spaces",
	"errors.providerFromAnotherOrganization": "Provider is from another organization",
	"errors.providerAlreadyInCircle": "Provider or Team is already in the circle",
	"errors.alreadyUsed": "Entered Email or Phone is already used, please log in.",
	"errors.validation.profile.firstName.required": "First Name should be present",
	"errors.validation.profile.lastName.required": "Last Name should be present",
	"errors.validation.profile.phone.format": "Phone should contain only +, - and digits",
	"errors.validation.profile.phone.required": "Phone is required",
	"errors.validation.profile.phoneHome.required": "Home phone number is required",
	"errors.validation.profile.phoneHome.format": "Phone number should contain between 8 and 14 numbers",
	"errors.validation.profile.phone.short": "Phone is too short",
	"errors.validation.profile.dob.format": "Incorrect date format",
	"errors.validation.profile.dob.required": "Date of birth is required",
	"errors.validation.profile.dob.minDate": "Date of birth cannot be before 01-01-1900.",
	"errors.validation.profile.email.format": "Email is invalid, please provide another",
	"errors.validation.profile.email.required": "Email is required",
	"errors.validation.profile.username.required": "Username is required",
	"errors.validation.profile.aliasName.required": "Alias is required",
	"errors.validation.profile.username.format": "Invalid format. Please use letters, numbers, . - _. Also + and @ allowed only once. No spaces.",
	"errors.validation.profile.aliasName.format": "Please enter a valid alias. Only letters, numbers, underscores and hyphens are allowed",
	"errors.validation.profile.username.minCharacters": "Username must contain at least 3 characters",
	"errors.validation.profile.aliasName.minCharacters": "Alias must contain at least 1 character",
	"errors.validation.profile.postalCode.format": "Please enter valid Postal / ZIP code for you region. For example: {example}",
	"errors.validation.profile.ssn.format": "Allowed formats: full 9 digits (e.g. 123456789) or last 4 digits (e.g. 6789)",
	"errors.validation.profile.workingHours.required": "Please, fill all fields or clear all to save",
	"errors.validation.common": "Record is invalid",
	"errors.username.conflictsWithExistingData": "Username has already been used. Please provide another!",
	"errors.username.alreadyTaken": "This username has already been taken. Please provide another.",
	"errors.username.required": "This field is required",
	"errors.aliasName.alreadyTaken": "This alias has already been taken. Please provide another.",
	"errors.ssn.alreadyTaken": "SSN has already been taken",
	"errors.ssn.alreadyTakenBy": "SSN has already been taken by {name}",
	"errors.fieldAlreadyTaken": "{field} has already been taken by {name}",
	"errors.appointment.timeSlotNotAvailable": "This time slot is no longer available.\nPlease choose another time.",
	"errors.appointment.pricingNotAvailable": "Pricing is not available for current date",
	"errors.appointment.thirdPartyError": "Service in not available",
	"errors.appointment.unavailableVirtualRoom": "The room is not yet available",
	"errors.appointment.mediaAccessDenied": "Can't access your camera\nPlease, give access to your computer's camera and microphone",
	"errors.appointment.copay": "Please enter valid payment amount",
	"errors.validation.invalidLoginEmail": "Invalid format. Please re-enter the email address using the standard format: example@example.com",
	"errors.validation.invalidLoginPhone": "Invalid format. Phone number should contain at least 10 digits and include area code.",
	"errors.validation.invalidLoginUsername": "Username must be 3–70 characters and can include letters, numbers, . - _. Also + and @ allowed only once. No spaces.",
	"errors.validation.alreadyExists": "The user with this email/phone already exists",
	"errors.validation.alreadyTakenByUsers": "Something is wrong with the E-mail AND Phone number. Please check",
	"errors.validation.separator": " or ",
	"errors.longRequest.408": "It takes too long to process the operation. Please check your internet connection and try again later.",
	"errors.longRequest.502.504": "Server is not responding, please, try again later or skip this step",
	"errors.familyMember.invitation": "Couldn't find family member invitation",
	"error.alreadyTakenEmail": "Email is already taken",
	"error.invalidPhoneNumber": "Phone number is invalid or already used, please provide another",
	"errors.formFields.phoneNumber": "Incorrect phone number. Please check and try again.",
	"errors.securityLink": "This link cannot be accessed due to security restrictions. Please try again later.",
	"errors.provideAdditionalInsuranceDetails": "Please provide additional insurance details or delete it to proceed.",
	"submit.signup": "Proceed",
	"submit.login": "Log in",
	"submit.signin": "Sign in",
	"submit.fillProfile": "Confirm",
	"submit.recoverPassword": "Send request",
	"submit.recoverConfirm": "Back to login",
	"submit.createPassword": "Save password",
	"submit.expiredToken": "Got it",
	"submit.signUp": "Sign up",
	"submit.clickHere": "Click here",
	"submit.registerHere": "Register here",
	"submit.login.azure": "Sign in with Microsoft",
	"submit.signUp.azure": "Sign Up with Microsoft",
	"submit.signUp.azure.description": "Please complete registration with Microsoft authentication",
	"submit.getInLine": "Get in line",
	"support.helpCenter": "Help Center",
	"support.needHelp": "Do you need help with {name} app?",
	"support.appVersion": "App version",
	"support.platformVersion": "Platform version",
	"titles.accessDenied": "Access denied",
	"titles.createPassword": "Create new password",
	"titles.expiredToken": "Sign up link expired",
	"titles.expiredConfirmation": "Confirmation link expired",
	"titles.fillProfile": "Personal details",
	"titles.login": "Log in to {brandName}",
	"titles.recoverConfirm": "Recovery link sent",
	"titles.recoverPassword": "Recover password",
	"titles.signup": "Sign up for {brandName}",
	"titles.confirmMyPhoneNumber": "I confirm my number",
	"titles.confirmMyEmail": "I confirm my email",
	"report.title": "Please select a problem to continue",
	"report.danger": "If someone is in immediate danger, call local emergency services.",
	"general.careProvidersTitle": "Care providers",
	"previewableBlock.more": "View more",
	"previewableBlock.less": "View less",
	"generalSurveys.noSurveys": "You have no service satisfaction info",
	"intro.common.logout": "Click here to logout from the app",
	"intro.common.circlesMenu": "Invite someone to the circle",
	"intro.circles.inviteFamilyMember": "Invite someone to join the family circle",
	"intro.circles.assignCaregiver": "Assign someone as caregiver who can act on behalf of patient",
	"intro.circles.inviteProviderMember": "Invite a provider in the organization to join the circle",
	"intro.circles.removeProviderMember": "Remove provider from the provider circle",
	"intro.messages.generalChannel": "Click on tab to chat to all providers and family",
	"intro.messages.providerChannel": "Private chat for providers only",
	"intro.messages.familyChannel": "Private chat for the patient's family only",
	"intro.messages.searchChat": "Search for a chat",
	"intro.messages.selectChat": "Select a chat",
	"intro.messages.selectChannel": "Select a channel",
	"intro.messages.typeFilter": "Select a type of chats",
	"intro.messages.socialChatArchived": "The social chat is archived because providers don't have access to it. Please, write to the practice chat or directly to the provider.",
	"intro.messages.typeMessage": "Type your message here",
	"intro.messages.answerSurvey": "Click to answer the survey",
	"intro.messages.patientName": "Click patient's name to see the providers and programs",
	"intro.messages.patientContext": "Everything you see is related to this patient",
	"intro.messages.patientProgram": "Click to see program surveys",
	"intro.messages.programFilter": "Filter the list of patients",
	"notificationScreen.title": "Notice",
	"notificationScreen.providerWithoutPatients.notification": "Circles are only available for patients and their family members.",
	"notificationScreen.providerWithoutPatients.instructionTitle": "How to become a patient or a family member (caregiver) in {brandName}?",
	"notificationScreen.providerWithoutPatients.instructionBody": "In order to become a patient ask your doctor whether your clinic is already connected to {brandName} and if yes, ask them to enroll you to one of the {brandName} Care Programs available in your clinic. Since enrolled, you will be able to invite family members to your Circle of care. In order to become a family member (caregiver) of a patient ask your relatives who are already enrolled to {brandName} Care Program to invite you to their family circle.",
	"notificationScreen.providerWithoutPatients.commonTitle": "Already a patient or a family member?",
	"notificationScreen.providerWithoutPatients.commonBody": "If you have been already enrolled to a program by your Doctor, but still can't see your Healthboard, try to update your email address.",
	"routes.patientViewProfile": "patient profile",
	"routes.providerViewProfile": "provider profile",
	"routes.userViewProfile": "user profile",
	"routes.providerMemberProfile": "provider circle member profile",
	"routes.familyMemberProfile": "family member profile",
	"routes.generalSurveys": "general surveys",
	"routes.parentProvider": "main care provider",
	"routes.patientInfo": "patient info",
	"routes.patientHealthboard": "patient healthboard",
	"routes.providerInfo": "provider info",
	"routes.settings": "settings",
	"routes.paymentMethods": "payment methods",
	"routes.support": "support",
	"routes.documentation": "documentation",
	"routes.circleOfCare": "circle of care",
	"routes.data": "data",
	"routes.program": "programs",
	"role.admin": "admin",
	"dialog.common.invite": "Invite more people to the chat",
	"dialog.success.joinCircle": "You've joined Patient's Provider Circle",
	"dialog.titles.joinCircle": "Join a Patient’s Provider Circle",
	"dialog.titles.assignProviderToPatient": "Assign new Provider to the Patient",
	"dialog.titles.assignProviderOrTeamToPatient": "Assign new Provider or Team to the Patient",
	"dialog.common.noPatients": "If the Patient doesn’t appear in search they may not be in our system or may already be assigned to you.",
	"dialog.titles.addDependent": "Add Child/Dependent to the System",
	"dialog.common.assign": "Assign",
	"dialog.common.addPatient": "Add Patients to the System",
	"dialog.common.defaultPatient": "ENTER THE USERNAME OR NAME OF A PATIENT WHOSE PROVIDER CIRCLE YOU’D LIKE TO JOIN",
	"dialog.common.addNewPatient": "Add new Patient",
	"dialog.common.patientWasAdded": "Patient has been added to the System",
	"dialog.common.defaultProvider": "ENTER THE USERNAME OR NAME OF A PROVIDER OR TEAM YOU’D LIKE TO ASSIGN TO THE PATIENT.",
	"dialog.common.selectTab": "SELECT A NECESSARY TAB TO MAKE YOUR RESULT MORE PRECIS",
	"dialog.common.assignProvider": "Assign Provider",
	"dialog.common.assignProviderOrTeam": "Assign Provider or Team",
	"dialog.common.inviteCaregiver": "Invite Caregiver",
	"dialog.common.inviteMember": "Invite Member",
	"dialog.common.invitePerson": "Invite Person",
	"dialog.common.reinvite": "Reinvite",
	"dialog.common.searchProvider": "Search for a Provider or Team...",
	"dialog.common.searchPatient": "Search for a Patient...",
	"dialog.common.addAnotherPatient": "Do you want to add another Patient to the System?",
	"dialog.common.alreadyMember": "Already a member?",
	"dialog.common.changesNotSave": "Changes wouldn't be saved. Are you sure?",
	"addPatient.dialog.title": "Add patient to your organization",
	"addPatient.dialog.subtitle": "This patient may be an existing user. Please check the patient details below and add patient if the patient is the correct one. If not please go back and use a different email/phone.",
	"dialog.titles.addPatient": "Add patient",
	"dialog.titles.emergencyContact": "Patient Emergency contact (optional)",
	"dialog.titles.emergencyContactRole": "Please, pay attention! Assigning the role is given full access to a Patient’s profile to act and manage the system on the Patient’s behalf.",
	"dialog.titles.andOr": "and / or",
	"dialog.titles.and": "and",
	"dialog.titles.join": "Join",
	"dialog.titles.accessRequested": "Access requested",
	"dialog.titles.copiedToClipboard": "Copied to clipboard",
	"dialog.titles.shareableLink": "You can past shareable link into another program",
	"documentation.common.frontSide": "front side",
	"documentation.common.backSide": "back side",
	"documentation.common.addPhoto": "Add a photo of the ",
	"documentation.common.title": "Profile Documentation",
	"documentation.attached.title": "Uploaded documents",
	"documentation.paperConsents.title": "Paper consents",
	"document.common.title": "Documentation",
	"documentation.consent.revoked": "Revoked",
	"documentation.consent.active": "Active",
	"documentation.consent.expired": "Expired",
	"dependent.form.selectRoleTitle": "Select your role",
	"dependent.form.addDependentTitle": "Add Dependent",
	"dependent.form.addChildTitle": "Add Child",
	"dependent.form.addDependentSubTitle": "Please, pay attention! All data will be stored in a secure way and won`t be editable anymore.",
	"dependent.form.relationshipSubTitle": "Please specify your relationship.",
	"dependent.form.relationshipExistSubTitle": "This profile already exists. Please specify your relationship.",
	"dependent.form.relationshipLabel": "Relationship",
	"dependent.form.parentTitle": "Parent",
	"dependent.form.guardianTitle": "Guardian",
	"dependent.form.proxyTitle": "Proxy",
	"dependent.form.careUserIdError": "Current user already taken",
	"dependent.form.parentInfo": "You are the Mother or Father of the Person you are adding",
	"dependent.form.guardianInfo": "You are the legal guardian of the Person you are adding ",
	"dependent.form.proxyInfo": "You are the legal Healthcare Proxy of the Person you are adding",
	"dependent.form.createComplete": "Your request is pending verification. \nPlease bring the power of attorney or health proxy documentation to the first visit for verification.",
	"dependent.form.unverifiedRequest": "Your request has not been approved. \nPlease bring the power of attorney or health proxy documentation to the first visit for verification.",
	"dependent.form.profileCreated": "{name}’s profile has been created",
	"dependent.form.becomeParent": "You became the Parent for {name}.",
	"dependent.dependentExists": "This person already has a parent/guardian in their Family Circle. Please ask this person to invite you to join the family circle.",
	"dependent.management.requestPending": "{careUser} wants to be a guardian/proxy for {dependent}. In case if you confirm this relationship all PII and PHI of the {dependent} will be seen and could be managed by {careUser}.",
	"dependent.management.removeConfirm": "Are you sure you want to deny the request?",
	"dependent.management.emptyMessage": "No requests at the moment",
	"dependent.management.appointmentPendingStatus.request": "{visitType} request for {careUser} and {provider}.",
	"dependent.management.appointmentPendingStatus.scheduled": "Scheduled by {scheduleUser}, {role}.",
	"dependent.management.appointmentPendingStatus.confirmed": "Confirmed by {signProvider}",
	"dependent.management.appointmentPendingStatus.declined": "Declined by {signProvider}",
	"dependent.management.appointmentPendingStatus.expired": "Request expired",
	"dashboard.filterResults": "Filter results",
	"dashboard.table.time": "Time",
	"dashboard.table.name_mrn": "Name/ID",
	"dashboard.table.dob_phone": "DOB/Phone",
	"dashboard.table.reason": "Appointment Type",
	"dashboard.table.location_service": "Location/Service",
	"dashboard.table.provider_room": "Provider/Room",
	"dashboard.table.status_payment": "Status/Payment",
	"dashboard.table.moveToFront": "Move to Front",
	"dashboard.table.changeStatus": "Change Status",
	"dashboard.table.assignRoom": "Assign Room",
	"dashboard.table.changePaymentStatus": "Change Payment Status to Paid",
	"dashboard.table.editPaymentAmount": "Edit Payment Amount",
	"dashboard.table.name": "Name",
	"dashboard.filter.filterVisits": "Filter Visits",
	"dashboard.filter.location": "Location",
	"dashboard.filter.service": "Service",
	"dashboard.filter.status": "Status",
	"dashboard.filter.clearAll": "Clear all",
	"dashboard.table.emptyFilterMessage": "No results match the filter criteria.\nPlease try to refine your query using other indicators.",
	"dashboard.table.emptyMessage": "No visits for this day.\nPlease try to refine your query using other indicators.",
	"dashboard.record.addRecord": "Add a Record",
	"dashboard.record.patientInfo": "Patient information",
	"dashboard.record.aboutVisit": "About visit",
	"dashboard.record.visitReason": "Appointment Type",
	"dashboard.record.room": "Room",
	"dashboard.record.paymentStatus": "Payment status",
	"dashboard.record.selectType": "Select the type",
	"dashboard.record.addReason": "Add the reason",
	"dashboard.record.locationExample": "e.g. Murabella; Palencia",
	"dashboard.record.serviceExample": "e.g. Laboratory",
	"dashboard.record.chooseTime": "Choose time",
	"dashboard.record.changeTime": "Change time",
	"dashboard.record.addInLine": "Add in line",
	"dashboard.record.addInLineNow": "Add in line on now",
	"dashboard.record.visitTime": "Visit Time",
	"dashboard.record.visitTime.map": "Visit time",
	"dashboard.record.validTime": "You can get in line only from {startTime} to {endTime}",
	"dashboard.record.updateVisitDetails": "Update visit details",
	"dashboard.record.notWorkingDay": "You can not get in line on a day off. Please, try again on a weekday",
	"dashboard.modal.title": "Do you want to proceed?",
	"appointments.visitType": "Visit Type",
	"appointments.myProviders": "My Providers",
	"appointments.seeAProvider": "Get Care",
	"appointments.pharmacies": "pharmacies",
	"appointments.successScheduleMsg": "Your visit is scheduled",
	"appointments.successSchedulePendingMsg": "Your visit request has been submitted. The Provider will confirm the visit.",
	"appointments.specialization": "Specialization",
	"appointments.emptyProviders": "No Available Providers for this day.",
	"appointments.emptySlots": "No Available slots for this day.",
	"appointments.confirmLeaveMessage": "Yes, start over",
	"appointments.confirmModalTitle": "If you close this page, you will have to start over. \nAre you sure?",
	"appointments.confirmModalText": "However, Patient info will be saved.",
	"appointments.form.book4me": "Book for me",
	"appointments.chooseOrganization": "Choose Organization",
	"appointments.emptyOrganizations": "You cannot schedule visit in your Organization(s) yet.\nPlease contact you Provider.",
	"appointments.emptyVisitTypes": "Sorry, the organization has no visits to schedule.\nPlease contact your Provider.",
	"appointments.form.step1.title": "New Visit",
	"appointments.form.step1.subTitle": "Who needs care?",
	"appointments.form.step2.title": "Get Care",
	"appointments.form.step2.subTitle": "for {user}",
	"appointments.form.step1.addNewPrimary": "Someone else?",
	"appointments.form.step1.addNewSecondary": "Add someone new",
	"appointments.form.consentForm": "Consent Form",
	"appointments.form.patientInfo": "Patient Info",
	"appointments.form.patientInfo.subtitle": "Please complete profile",
	"appointments.form.visitDetails": "Visit Details",
	"appointments.form.insuranceDetails": "Insurance Details",
	"appointments.form.insuranceDetails,success": "Insurance Data successful update",
	"appointments.form.noCoverage": "Insurance not verified",
	"appointments.form.noCoverage.tryAgain": "The insurance data has not been verified. Are you sure you want to save it?",
	"appointments.form.healthPlan": "Health plan",
	"appointments.form.changePlan": "Change plan",
	"appointments.form.searchPlan": "Search plan",
	"appointments.form.planNotListed": "Plan is not listed or Self-pay",
	"appointments.form.searchInsurance": "Search an Accepted Insurance Plan",
	"appointments.form.availableProviders": "Available Providers",
	"appointments.form.noAvailableProviders": "No Available Time Slots",
	"appointments.form.dateFilter": "Pick a day",
	"appointments.form.preferredPharmacy": "Preferred Pharmacy",
	"appointments.form.pharmacyLocation": "Pharmacy Location",
	"appointments.form.changePharmacy": "Change Pharmacy",
	"appointments.form.selectFromMap": "Select from Map",
	"appointments.form.searchForPharmacy": "Search for pharmacy",
	"appointments.form.emptyPharmacyList": "Enter the ZIP code of the pharmacy which you want to select as preferred.",
	"appointments.form.searchByZipCode": "Search by ZIP code",
	"appointments.form.showWithMailOrder": "Show pharmacies with mail order",
	"appointments.form.emergencyContact": "Emergency Contact",
	"appointments.form.guarantorInformation": "Guarantor information",
	"appointments.form.additionalInformation": "Additional Information",
	"appointments.form.completeYourProfile": "Check your profile information",
	"appointments.form.completeYourProfile.description": "Ensure this information is accurate and complete any missing details.",
	"appointment.form.patientDoc": "Patient Demographics",
	"appointment.form.hipaa": "HIPAA Consent",
	"appointment.form.costTitle": "Your Cost",
	"appointment.form.videoVisit": "Video Visit",
	"appointment.form.copayIsNotReceived": "Insurance copay was not found",
	"appointment.form.verifyInformation": "Please verify the insurance information was entered correctly or contact support for assistance",
	"appointment.form.overlap": "There is already an existing appointment at this time. Do you want to continue?",
	"appointment.form.error.notAvailableProvider.forSelectedService": "Provider is not available for selected service in selected location",
	"appointment.form.error.notAvailableProvider.forThisTime": "Provider is not available for this time",
	"appointment.form.error.notAvailableProvider.insuranceNotAccepted": "This insurance is not accepted. Please update the Health plan",
	"appointment.form.error.notAvailableProvider.notAccepted": "Not Accepted",
	"appointment.form.error.notAvailableProvider.combined": "Provider is not available for selected date and time or for selected service in selected location. Please choose other parameter of visit",
	"appointment.details.paymentAmount.title": "Payment amount, USD",
	"appointment.details.paymentStatus.title": "Payment status ",
	"appointment.details.visitDuration.title": "Visit Duration",
	"appointment.details.pendingMessage.visit.title": "Please wait for confirmation from provider",
	"appointment.documents.addDocument.title": "Add document",
	"appointment.documents.description": "Please, select the category and subcategory for the document.",
	"appointment.documents.successUpload": "Document uploaded",
	"appointment.documents.deleteMessage": "Are you sure you want to delete this document?",
	"appointment.surveys.title": "Forms",
	"appointment.surveys.title.upcoming": "Incomplete, Tap to answer",
	"appointment.surveys.notificationProvider": "Pre-visit form must be completed before the visit.",
	"appointment.surveysAndConsent.notificationProvider": "Pre-visit and Consent forms must be completed before the visit.",
	"appointment.programForm": "Program form",
	"appointment.preVisitForm": "Pre-visit form",
	"appointment.postVisitForm": "Post-visit form",
	"appointment.postVisitForm.notificationPatientLink": "Complete form",
	"appointment.consent.title": "Consent forms",
	"appointment.consent.signed": "Signed",
	"appointment.consent.notSigned": "Not signed",
	"appointment.consent.notificationProvider": "Consents should be signed by Patient before the visit.",
	"appointment.consent.notificationPatient": "Consents should be signed before the visit.",
	"appointment.consent.notificationPatientLink": "See consents",
	"appointment.consentAndSurvey.notificationPatientLink": "Complete",
	"appointment.consent.techConnectNotification": "Please note! Tech Connect has live queue on premise, so someone could bein front of you in line.",
	"appointment.consent.inLineNotification": "Please note there is a live queue onsite, so someone could be in front of you in line.",
	"appointment.consent.details.titleProvider": "Consent Form",
	"appointment.consent.details.titlePatient": "Signatures required",
	"appointment.consent.details.type": "Pre-visit Consent (required)",
	"appointment.consent.consentFor": "Consent for {serviceName}/{organizationName}",
	"appointment.consent.consentVersion": "Version",
	"appointment.consent.paper": "Paper consent",
	"appointment.consent.version": "Version {version}",
	"appointment.consent.titleMsg": "Sign Consent before the Visit",
	"appointment.consent.mainConsentTitle": "Please accept the {name} form before starting a conversation with a Provider",
	"appointment.electronicConsent.mainTitle": "Assigned Consent by {name}, Provider",
	"appointment.electronicConsent.details.titlePatient": "Signature required",
	"appointment.visitConfirmed": "Your visit is confirmed",
	"appointment.payment.title": "Payment",
	"appointment.payment.basePrice": "Base price",
	"appointment.payment.copay": "Copay",
	"appointment.payment.discount": "Discount",
	"appointment.payment.total": "Total",
	"appointment.payment.discountTitle": "Do you have a discount coupon?",
	"appointment.payment.discountText": "Enter your coupon code below",
	"appointment.payment.couponCode": "Coupon code",
	"appointment.payment.couponCodeAutomatic": "Coupon has been successfully applied",
	"appointment.payment.apply": "Apply",
	"appointment.payment.discountError": "Invalid Code",
	"appointment.payment.successMessage": "Payment successful",
	"appointment.payment.charged": "Your credit card will not be charged until the visit is completed",
	"appointment.payment.errorTitle": "Payment Error",
	"appointment.payment.errorMessage": "The payment was unsuccessful and your card was not charged. Please try again.",
	"appointment.payment.errorProvider": "This provider does not yet accept online payments",
	"appointment.payment.refunded": "Refunded",
	"appointment.payment.submitted": "Payment Submitted",
	"profile.payment.paymentMethods": "Payment methods",
	"profile.payment.addPaymentMethod": "Add Payment Method",
	"profile.payment.description": "Your cards associated with clinic payment accounts.",
	"profile.payment.hint": "Payment methods are saved separately for different accounts.\nSame card can appear more than once.",
	"profile.payment.noSavedPaymentMethods": "No saved payment methods",
	"profile.payment.expired": "Expired",
	"profile.payment.onlyForOrganizationMessage": "Adding payment methods is available only when an organization is set",
	"profile.payment.subscriptionMessage": "This payment method can't be removed right now because it's being used for an active subscription.",
	"profile.payment.removeMessage": "Are you sure you want to remove this payment method?",
	"profile.payment.removeUnsuccessfullyMessage": "The card removal was unsuccessful. \nPlease try again.",
	"profile.payment.informationAboutTheOrganizationTitle": "Information about the organization",
	"profile.payment.informationAboutTheOrganizationDescription": "To add a card, first choose the organization and location where you will use it.",
	"profile.payment.chooseOrganization": "Choose Organization",
	"profile.payment.chooseLocation": "Choose Location",
	"profile.payment.cardSuccessfullyAdded": "Card successfully added",
	"profile.payment.cardWasNotAdded.": "Card wasn't added. \nPlease try again.",
	"profile.payment.cardMenu.seeAssociatedLocations": "See associated locations",
	"profile.payment.cardMenu.removePaymentMethod": "Remove payment method",
	"profile.payment.popup.locationsInfo": "This payment method is available at the following clinic locations:",
	"profile.payment.removeSuccessfullyMessage": "Payment method removed successfully",
	"profile.payment.removeErrorMessage": "Payment method removal was unsuccessful. Please try again.",
	"profile.payment.fields.location": "Location",
	"profile.payment.fields.organization": "Organization",
	"profile.payment.addingLocationInfo": "Adding this location may also add other locations linked to the same payment account.",
	"profile.payment.addCardForFutureUse": "Add a card for future use.",
	"appointment.list.tabs.addAppointment": "Add Visit",
	"appointment.list.tabs.upcoming": "Upcoming",
	"appointment.list.tabs.inLine": "In Line",
	"appointment.list.tabs.history": "History",
	"appointment.list.card.startVisit": "Start Visit",
	"appointment.list.card.confirm": "Confirm",
	"appointment.list.card.provider": "Provider",
	"appointment.list.card.service": "Service",
	"appointment.list.card.reasonForVisit": "Appointment Type",
	"appointment.list.card.walkIn": "Walk-In",
	"appointment.list.card.yourCost": "Your cost",
	"appointment.list.card.patient": "Patient",
	"appointment.list.card.payment": "Payment",
	"appointment.list.card.videoVisitAW": "Please, join from the mobile app",
	"appointment.list.card.location": "Location",
	"appointment.upcoming.popup.title": "Upcoming {visitType}",
	"appointment.history.popup.title": "{status} {visitType}",
	"appointment.popup.title": "{status} {visitType}",
	"appointment.pending.popup.title": "Pending {visitType}",
	"appointment.actions.availableCheckInTime": "You can check-in one hour before visit",
	"appointment.actions.availableConfirm": "You can confirm 72 hours before the visit",
	"appointment.actions.checkIn": "Check-In",
	"appointment.actions.noShow": "No Show",
	"appointment.actions.complete": "Complete",
	"appointment.actions.cancelVisit": "Cancel Visit",
	"appointment.actions.pay": "Pay",
	"appointment.actions.payForVisit": "Pay for Visit",
	"appointment.actions.checkIn.warning": "Payment is required before check-in",
	"appointment.actions.startVisit.warning": "Payment is required before the visit",
	"appointment.actions.cancelVisitConfirmation": "This visit will be canceled. \nAre you sure?",
	"appointment.actions.cancelUrgentVisitConfirmation": "This visit will be canceled and payment will be refunded. Are you sure?",
	"appointment.actions.yesCancel": "Yes, Cancel",
	"appointment.actions.noGoBack": "No, Go back",
	"appointment.actions.yesChange": "Yes, change",
	"appointment.actions.changePaymentStatus": "Are you sure you want to change the Payment Status to Paid?",
	"appointment.actions.askProviderForCancel": "Contact your provider to cancel this visit",
	"appointment.actions.paymentRequired": "Payment is required",
	"appointment.actions.selectYourSlot": "Select your slot",
	"appointment.info.transactionDate": "Transaction date",
	"appointment.info.transactionId": "Transaction ID",
	"appointment.inlineVisit.status": "In-Line",
	"appointment.inlineVisit.availableTimeSlots": "Today’s Available Time Slots",
	"appointment.inlineVisit.success.inLine.title": "You are now in line",
	"appointment.inlineVisit.success.inLine.description": "Please note there is a live queue onsite, so someone could be in front of you in line",
	"appointment.inlineVisit.error.noAvailableTime": "Sorry, there is no available time today",
	"teams.teamMember": "Team members",
	"teams.teamCircle": "Team circle",
	"teams.teamCommunityEmpty": "please select your individual account to interact with communities",
	"healthboard.invitations.card.subTtitle": "{role} role for {name}",
	"healthboard.invitations.card.title": "Join {name}’s Family Circle",
	"healthboard.invitations.modal.title": "Join Family Circle",
	"healthboard.providersNavTitle": "Practice Providers",
	"healthboard.program.card.type": "Program Invite",
	"healthboard.appointments.mobileAppAvailable": "Available in the mobile app",
	"healthboard.appointments.paymentStatus.paid": "Paid",
	"healthboard.appointments.paymentStatus.unpaid": "Unpaid",
	"healthboard.appointments.paymentStatus.amountPending": "Amount Pending",
	"healthboard.appointments.paymentStatus.paidAmount": "${paidAmount} paid",
	"healthboard.appointments.paymentStatus.refunded": "${paidAmount} refunded",
	"healthboard.appointments.paymentStatus.unpaidAmount": "${price} unpaid",
	"healthboard.appointments.paymentStatus.pendingPaymentInfo": "Pending payment info",
	"healthboard.appointments.paymentStatus.processingPayment": "Processing Payment",
	"healthboard.appointments.paymentStatus.tapToPay": "${price} to pay",
	"healthboard.appointments.paymentStatus.totalToPay": "Total ${price}",
	"healthboard.appointments.paymentStatus.voided": "Payment voided ${paidAmount}",
	"healthboard.appointments.upcoming": "Upcoming Visits",
	"healthboard.appointments.history": "Visits History",
	"healthboard.title.upcomingAppointmentsEmpty": "No upcoming visits",
	"healthboard.text.upcomingAppointmentsEmpty": "Tap Get Care above to schedule a visit.",
	"healthboard.title.historyAppointmentsEmpty": "No history visits",
	"healthboard.text.historyAppointmentsEmpty": "Tap on Get Care button to schedule a visit",
	"healthboard.empty.forPatient": "Ask a provider to schedule a visit.",
	"healthboard.empty.forProviderInContext": "Tap Add Visit to schedule a visit.",
	"healthboard.empty.forProvider": "Go to the Patient's Visits context to schedule a visit.",
	"healthboard.title.appointments": "Visits",
	"healthboard.action.seeCompleted": "See completed",
	"healthboard.title.surveysCompleted": "Great! Keep up the good work!",
	"healthboard.text.surveysCompleted": "To Do List is Complete.",
	"healthboard.title.surveysEmpty": "To Do List is empty",
	"healthboard.title.todoEmpty": "Great Job! To Do List is empty",
	"healthboard.title.todoCompleted": "You have no completed To Dos yet",
	"healthboard.text.surveysEmpty": "Get care to become a patient and see your to do’s here.",
	"healthboard.title.dependentPending": "Your request is pending by provider",
	"healthboard.text.dependentPending": "Please bring your power of attorney or health proxy documentation to the first visit for verification.",
	"healthboard.title.dependentUnverified": "Your request has not been approved",
	"healthboard.text.dependentUnverified": "Please bring your power of attorney or health proxy documentation to the first visit for verification.",
	"healthboard.title.teamPlaceholder": "please select your individual account to interact with healthboard",
	"healthboard.notAvailable": "Not Available\nPlease contact support to setup Healthboard",
	"healthboard.filter.virtualVisit": "Virtual Visit",
	"healthboard.filter.clearFilters": "Clear filters",
	"healthboard.buttons.additionalResources": "See additional resources",
	"password.validation.title": "Password must include:",
	"password.validation.upperCase": "at least one upper case letter;",
	"password.validation.lowerCase": "at least one lower case letter;",
	"password.validation.number": "at least one number;",
	"password.validation.specCharacter": "at least one special character, except space;",
	"password.validation.charactersNumber": "at least 6 characters.",
	"virtualVisit.room.join": "{name} has joined the call",
	"virtualVisit.room.leave": "{name} has left the call",
	"virtualVisit.room.talking": "talking",
	"virtualVisit.room.isTalking": "{name} is talkin",
	"virtualVisit.room.multipleTalking": "{speakersCount} are talking",
	"virtualVisit.room.callMembers": "Call members",
	"virtualVisit.room.pendingInvitation": "(Pending invitation)",
	"virtualVisit.room.sentInvitation": "Invitation(s) Sent",
	"virtualVisit.room.invitationRemoved": "Invitation link is removed",
	"virtualVisit.paymentGate.title": "Complete payment",
	"virtualVisit.paymentGate.description": "Payment is required before the visit. Please complete your payment to join the visit.",
	"virtualVisit.paymentGate.yourCost": "Your Cost:",
	"virtualVisit.paymentGate.total": "Total {amount}",
	"virtualVisit.paymentGate.pay": "Pay",
	"virtualVisit.title": "{visitType} for {name}",
	"virtualVisit.room": "Room",
	"virtualVisit.duration": "Duration",
	"virtualVisit.error.alreadyInCall": "Allready in call",
	"virtualVisit.unstableConnection": "Unstable internet connection",
	"virtualVisit.error.sessionExpired.title": "Connection Issue",
	"virtualVisit.error.sessionExpired": "Failed to connect to session",
	"virtualVisit.error.notConnected": "Couldn't perform action because you are not connected to the network",
	"virtualVisit.error.cameraMicrophoneUnavailable.title": "Camera/microphone unavailable",
	"virtualVisit.error.cameraMicrophoneUnavailable.description": "The camera/microphone is in use by another application. In order to proceed, please close all other applications.",
	"virtualVisit.error.noDevicesFound.title": "No devices",
	"virtualVisit.error.noDevicesFound": "No devices were found to provide the media stream",
	"virtualVisit.error.noValidConstraints.title": "No valid constraints",
	"virtualVisit.error.noValidConstraints": "Video and audio were both disabled. You need to enable at least one",
	"virtualVisit.error.notSupported.title": "Not Supported",
	"virtualVisit.error.notSupported": "Something in the user media request is not supported",
	"virtualVisit.error.expired.title": "Visit Expired",
	"virtualVisit.error.expired": "Access to visit has been expired",
	"virtualVisit.error.invalidLink": "This link is not valid. Please check and try again.",
	"virtualVisit.error.visitCompleted": "The visit has been completed",
	"virtualVisit.error.callCompleted": "The call has been completed",
	"virtualVisit.virtualVisit": "Virtual visit",
	"virtualVisit.regural.placeholder.title": "You have joined the virtual waiting room",
	"virtualVisit.regural.placeholder.subtitle": "Please do not leave this screen. Your provider should be with you shortly.",
	"virtualVisit.placeholder.title": "Your visit will begin shortly",
	"virtualVisit.placeholder.subtitle": "The next available Provider will join the room",
	"virtualVisit.removeInvitationLink.description": "Are you sure you want to remove an invitation link for {email}?",
	"inOfficeVV.join": "Join visit",
	"inOfficeVV.code": "Code",
	"inOfficeVV.enterCode": "Please enter the visit code to join.",
	"inOfficeVV.error.invalid": "The code entered is invalid",
	"inOfficeVV.error.alreadyNotAvailble": "The room already is not available",
	"inOfficeVV.error.noteYetAvailable": "The room is not yet available",
	"virtualVisit.details.title": "Visit Details",
	"virtualVisit.details.appointmentProvider": "Visit provider",
	"virtualVisit.details.paymentAmount": "Payment amount",
	"virtualVisit.details.paymentAmountUsd": "Payment amount, USD",
	"virtualVisit.details.schedule": "Schedule",
	"virtualVisit.details.futureTime": "Please pick future time for the visit",
	"virtualVisit.details.visitScheduled": "Visit is scheduled",
	"virtualVisit.device.mic": "Your microphone:",
	"virtualVisit.device.video": "Your camera:",
	"virtualVisit.inviteGuest.title": "Invite Guest",
	"virtualVisit.inviteGuest.addGuest": "Add another guest",
	"virtualVisit.inviteGuest.description": "You can invite one or more guests to join this visit",
	"virtualVisit.test.cancel": "Cancel test",
	"virtualVisit.test.check": "Check video/audio",
	"virtualVisit.test.retest": "Re-test video/audio",
	"virtualVisit.test.test": "Test video/audio",
	"virtualVisit.test.continue": "or continue to",
	"virtualVisit.test.progress": "Testing in progress…",
	"virtualVisit.test.completed": "Test Complete",
	"virtualVisit.test.connectivity": "Connectivity",
	"virtualVisit.test.startsSoon": "Your visit starts soon",
	"virtualVisit.test.desc": "We recommend you make the system quality test before you start the visit. \nYou can be sure that audio/video quality allows you \nto make the visit without problems.",
	"virtualVisit.test.videoQuality": "Video Quality:",
	"virtualVisit.test.audioQuality": "Audio Quality:",
	"virtualVisit.test.videoSubtitle": "Move something in view of the camera to check that it is working.",
	"virtualVisit.test.audioSubtitle": "Say something in the microphone to check that it is working.",
	"virtualVisit.test.result.excellent": "Excellent",
	"virtualVisit.test.result.good": "Good",
	"virtualVisit.test.result.fair": "Fair",
	"virtualVisit.test.result.poor": "Poor",
	"virtualVisit.test.result.bad": "Bad",
	"virtualVisit.test.result.failure": "Failure",
	"virtualVisit.test.camera": "Camera",
	"virtualVisit.test.mic": "Microphone",
	"virtualVisit.test.description": "If you have audio and video problems, you can always check your devices in settings.",
	"virtualVisit.test.openSettings": "Open settings",
	"virtualVisit.test.deviceNotFound": "Device Not Found",
	"virtualVisit.test.video": "Video",
	"virtualVisit.test.audio": "Audio",
	"virtualVisit.test.noAudio": "Microphone: undefined",
	"virtualVisit.test.noVideo": "Camera: undefined",
	"virtualVisit.canceledByProvider": "The visit was canceled by provider",
	"virtualVisit.complete": "Visit сomplete",
	"virtualVisit.joinVirtualVisit": "You can join the virtual visit only at the office",
	"media.permissions.request.title": "Please give access to your microphone/camera",
	"media.permissions.request.description": "To make this call, we need permission to use your microphone and camera. Click the lock icon in your browser's address bar and allow access.",
	"media.permissions.mob.safari": "To grant permission to access your camera/microphone, go to your device Settings > Safari > Camera/Microphone.",
	"media.permissions.mob.chrome_ios": "To grant permission to access your camera/microphone, go to your device Settings > Privacy > Camera/Microphone > Chrome.",
	"media.permissions.mob.chrome_android": "To grant permission to access your camera/microphone, go to your device Settings > Apps > Chrome > Permissions.",
	"media.permissions.denied.title": "Can’t access your microphone/camera",
	"media.permissions.denied.chrome": "To make this call, we need permission to use your microphone and camera. Click the blocked camera icon in your browser's address bar.",
	"media.permissions.denied.safari": "To make this call, we need permission to use your microphone and camera. Click the Safari menu > Settings for website.",
	"media.permissions.denied.default": "To make this call, we need access to your microphone and camera. Please check the website permissions in your browser settings.",
	"virtualVisit.test.canAccessMicroCamera": "Can't access your microphone/camera",
	"virtualVisit.test.giveAccessMicroCamera": "Please, give access to your computer's microphone/camera to proceed.",
	"calendar.overlapAppointment": "There is already an existing appointment at this time. Do you want to continue?",
	"calendar.overwriteTitile": "You are about to overwrite further overlapping schedule. \nOverwrite it?",
	"calendar.overwrite": "Overwrite",
	"calendar.manageSchedule": "Manage Schedule",
	"calendar.edit.title": "Edit work schedule template",
	"calendar.read.title": "Work schedule",
	"calendar.addSchedule": "Add new schedule",
	"calendar.blockedSlots": "Blocked slots",
	"calendar.blocked": "Blocked",
	"calendar.editSchedule": "Edit schedule",
	"calendar.editBlock": "Edit Block",
	"calendar.blockSchedule": "Block schedule",
	"calendar.colorMarker": "Color marker",
	"calendar.diffSettins": "Selected range has different settings",
	"calendar.tabs.add": "Add schedule",
	"calendar.tabs.block": "Block slot(s)",
	"calendar.tabs.schedule": "Edit schedule",
	"calendar.tabs.repeat": "Edit repeat",
	"calendar.repeat.title": "Repeat",
	"calendar.repeat.noRepeat": "No repeat",
	"calendar.repeat.weekly": "Weekly",
	"calendar.repeat.weeklyOn": "Weekly on",
	"calendar.repeat.until": "until",
	"calendar.repeat.custom": "Custom",
	"calendar.repeat.endDate": "End date",
	"calendar.repeat.everyWeek": "Every week on:",
	"calendar.week.sunday": "Sun",
	"calendar.week.monday": "Mon",
	"calendar.week.tuesday": "Tue",
	"calendar.week.wednesday": "Wed",
	"calendar.week.thursday": "Thu",
	"calendar.week.friday": "Fri",
	"calendar.week.saturday": "Sat",
	"calendar.appointment.restrict": "You cannot schedule visits in {location}: {service}",
	"calendar.mobileWarning": "sorry this resolution is not supported.\nPlease use the device with a higher resolution to interact with calendar.",
	"calendar.repeat.currentDay": "Current day",
	"calendar.repeat.currentAndNext": "Current and following days",
	"calendar.repeat.followingDays": "Following days",
	"calendar.repeat.allDays": "All days",
	"calendar.legend.officeVisit": "Office visit",
	"calendar.legend.virtualVisit": "Virtual visit",
	"calendar.legend.pendingVisit": "Pending visit",
	"calendar.legend.blockedSlot": "Blocked slot",
	"calendar.appointmentForm.patientSearch": "Start typing to see list of Patients",
	"calendar.recursion.editWorkSlot": "Apply recurring schedule for",
	"calendar.recursion.editBlockkSlot": "Apply recurring schedule for",
	"calendar.recursion.removeWorkSlot": "Remove recurring schedule for",
	"calendar.recursion.removeBlockkSlot": "Remove recurring blocked slot for",
	"calendar.errors.insert.common": "Error during insert schedule",
	"calendar.errors.remove.common": "Error during remove schedule",
	"calendar.errors.search.common": "Error during load schedule calendar",
	"calendar.errors.update.common": "Error during update schedule",
	"calendar.errors.appointment.unavailableProvider": "Provider is not available for the whole duration of visit",
	"calendar.errors.appointment.patientTypeMismatch": "Selected Patient doesn't match the specified Patient Type",
	"calendar.errors.appointment.common": "Error during appointment schedule",
	"guarantor.addGuarantor": "Add guarantor",
	"guarantor.addAGuarantor": "Add a guarantor",
	"guarantor.removeMessage": "Are you sure you want to remove  {name} from the list? ",
	"guarantor.role.selfGuarantor": "I am the Guarantor",
	"guarantor.role.userNameGuarantor": "{name} is the Guarantor",
	"guarantor.selectGuarantor.description": "Select or add the person who will be financially responsible for any related charges.",
	"guarantor.selectGuarantor.addressProvide": "Please provide the guardian’s address to proceed.",
	"guarantor.fields.dob": "Date of Birth",
	"guarantor.fields.mobilePhone": "Phone Number",
	"guarantor.fields.email": "Email address",
	"guarantor.fields.gender": "Gender",
	"guarantor.fields.relation": "Relationship",
	"guarantor.fields.address1": "Address 1",
	"guarantor.fields.address2Optional": "Address 2 (Optional)",
	"guarantor.fields.city": "City",
	"guarantor.fields.state": "State",
	"guarantor.fields.postalCode": "Postal / ZIP code",
	"mobile.app.title": "We’re available on your mobile!",
	"mobile.app.getAppText": "Get the {name} app for your mobile device to be connected at any time",
	"task.seeLocations": "See locations",
	"task.upcoming": "Upcoming Task",
	"task.canceled": "Canceled task",
	"task.completed": "Completed Task",
	"task.assigned": "Assigned Task",
	"task.overdue": "Overdue",
	"task.dueToday": "Due Today",
	"task.dueTomorrow": "Due Tomorrow",
	"task.alreadyCompleted": "Task is already completed.",
	"task.selectOutcome": "Select task outcome:",
	"task.outcome": "Task outcome:",
	"task.acceptedFileTypes": "Accepted file types: pdf, jpg, jpeg, png.",
	"task.error.acceptedFileType": "Please choose accepted file type: pdf, jpg, jpeg, png",
	"task.error.acceptedFileSize": "Document should not be larger than 32MB",
	"task.error.uploadFailed": "Documents upload has failed. Please complete the task again",
	"googleMaps.miAway": " mi away",
	"googleMaps.closed": "Closed",
	"googleMaps.location": "Location",
	"googleMaps.about": "About",
	"googleMaps.workingHours": "Working hours",
	"googleMaps.popup.title": "Geo-locations",
	"googleMaps.popup.title.locations": "Locations",
	"patient.healthboard.value": "Value",
	"patient.healthboard.normalRange": "Normal Range",
	"patient.healthboard.title": "Patient Healthboard",
	"patient.healthboard.steps": "Steps",
	"patient.healthboard.steps.metric": "steps",
	"patient.healthboard.vitalsActivity": "Vitals & Activity",
	"patient.healthboard.distance": "Distance",
	"patient.healthboard.distance.metric": "mi",
	"patient.healthboard.bmi": "BMI",
	"patient.healthboard.weight": "Weight",
	"patient.healthboard.weight.metric": "lbs",
	"patient.healthboard.weight.metric.kg": "kg",
	"patient.healthboard.height": "Height",
	"patient.healthboard.height.metric.feet": "ft",
	"patient.healthboard.height.metric.feetAndInch": "ft & in",
	"patient.healthboard.height.metric.inches": "in",
	"patient.healthboard.height.metric.cm": "cm",
	"patient.healthboard.temperature.metric.celsius": "°C",
	"patient.healthboard.temperature.metric.fahrenheit": "°F",
	"patient.healthboard.medications": "Medications",
	"patient.healthboard.labTestResult": "Lab & Test Results",
	"patient.healthboard.vaccines": "Vaccines",
	"patient.healthboard.allergies": "Allergies",
	"patient.healthboard.contextOf": "In context of",
	"patient.healthboard.titleHistoric.bmi": "All BMI Data",
	"patient.healthboard.titleHistoric.blood_glucose": "All Blood Glucose Data",
	"patient.healthboard.titleHistoric.weight": "All Weight Data",
	"patient.healthboard.titleHistoric.height": "All Height Data",
	"patient.healthboard.titleHistoric.steps": "All Steps Data",
	"patient.healthboard.titleHistoric.distance": "All Distance Data",
	"patient.healthboard.titleHistoric.spo2": "All Oxygen Saturation Data",
	"patient.healthboard.titleHistoric.heart_rate": "All Heart Rate Data",
	"patient.healthboard.titleHistoric.all.blood_pressure": "All Blood Pressure Data",
	"patient.healthboard.titleHistoric.blood_pressure": "Blood Pressure Data",
	"patient.healthboard.titleHistoric.all.respiratory_rate": "All Respiratory Rate Data",
	"patient.healthboard.titleHistoric.respiratory_rate": "Respiratory Rate Data",
	"patient.healthboard.titleHistoric.bsa": "All Body Surface Area Data",
	"patient.healthboard.titleHistoric.body_temperature": "All Body Temperature Data",
	"patient.healthboard.average": "Average",
	"patient.healthboard.total": "Total",
	"patient.healthboard.graf.emptyState": "no data",
	"patient.healthboard.list.loadMore": "Load more",
	"patient.healthboard.saturation": "Oxygen Saturation (SpO",
	"patient.healthboard.saturation.index": "2",
	"patient.healthboard.saturation.metric": "%",
	"patient.healthboard.saturation.info": "Info",
	"patient.healthboard.saturation.description": "Oxygen saturation is a measure of the amount of oxygen in the protein (hemoglobin) in your red blood cells. To function properly, your body needs a certain level of oxygen circulating in the blood. Your red blood cells are loaded (saturated) with oxygen in the lungs and carry it throughout your body.",
	"patient.healthboard.saturation.mayoClinic": "Mayo Clinic Staff. (2018, December 1). Mayo Clinic. Hypoxemia Retrieved from ",
	"patient.healthboard.saturation.mayoClinicTitle": "Mayo Clinic",
	"patient.healthboard.myDevices": "My Devices",
	"patient.healthboard.ccd": "Health Record",
	"patient.healthboard.allSources": "All Sources",
	"patient.healthboard.source": "Source",
	"patient.healthboard.minMaxData": "Min-Max data",
	"patient.healthboard.totalData": "Total data",
	"patient.healthboard.averageData": "Average data",
	"patient.healthboard.devices": "Devices",
	"patient.healthboard.minMax": "Min-Max",
	"patient.healthboard.userDevices": "{name}'s Devices",
	"patient.healthboard.blood_pressure": "Blood Pressure",
	"patient.healthboard.blood_pressure.systolic": "Systolic",
	"patient.healthboard.blood_pressure.diastolic": "Diastolic",
	"patient.healthboard.blood_pressure.metric": "mmHg",
	"patient.healthboard.respiratory_rate": "Respiratory Rate",
	"patient.healthboard.respiratory_rate.metric": "breaths/min",
	"patient.healthboard.clickSeeAllData": "Click to see all data",
	"patient.healthboard.heart_rate": "Heart Rate",
	"patient.healthboard.heart_rate.metric": "BPM",
	"patient.healthboard.bsa": "Body Surface Area (BSA)",
	"patient.healthboard.bsa.metric": "m",
	"patient.healthboard.bsa.metricIndex": "2",
	"patient.healthboard.body_temperature": "Body Temperature",
	"patient.healthboard.blood_glucose": "Blood Glucose",
	"patient.healthboard.body_temperature.metric.fahrenheit": "°F",
	"patient.healthboard.body_temperature.metric.celsius": "°C",
	"patient.healthboard.blood_glucose.metric.millimoles_per_liter": "mmol/L",
	"patient.healthboard.blood_glucose.metric.milligrams_per_deciliter": "mg/dL",
	"patient.healthboard.labTestHistory.selector.five": "Last 5 results",
	"patient.healthboard.labTestHistory.selector.ten": "Last 10 results",
	"patient.healthboard.labTestHistory.selector.all": "All results",
	"patient.healthboard.labTestHistory.selector.custom": "Custom",
	"patient.healthboard.labTestHistory.modalTitle": "Test Results Details",
	"patient.healthboard.labTestHistory.range": "Range",
	"patient.healthboard.fitBit": "FitBit",
	"patient.healthboard.withings": "Withings",
	"patient.healthboard.apple": "Apple Health",
	"patient.healthboard.googleFit": "Google Fit",
	"patient.healthboard.tenovi": "Tenovi",
	"patient.healthboard.iHealth": "iHealth",
	"patient.healthboard.local": "Manual Input",
	"patient.portal.vitals_and_activity": "Vitals & Activity",
	"patient.portal.medications": "Medications",
	"patient.portal.immunizations": "Immunizations",
	"patient.portal.lab_and_test_results": "Lab & Test Results",
	"patient.portal.allergies": "Allergies",
	"patient.portal.conditions": "Conditions",
	"patient.portal.social_histories": "Social History",
	"patient.portal.family_histories": "Family History",
	"patient.portal.health_record": "Health Record",
	"patient.portal.encounters": "Encounters",
	"patient.portal.activity_log": "Activity Log",
	"patient.portal.activity_log.emptyState": "Activity",
	"patient.portal.medications.prescribedDate": "Prescribed Date",
	"patient.portal.medications.pharmacy": "Pharmacy",
	"patient.portal.medications.directions": "Directions",
	"patient.portal.medications.address": "Address",
	"patient.portal.medications.startDate": "Start date",
	"patient.portal.medications.selfReported": "Self Reported",
	"patient.portal.allergies.severity": "Severity",
	"patient.portal.allergies.type": "Allergy Type",
	"patient.portal.allergies.effectiveDate": "Effective Date",
	"patient.portal.conditions.active": "Active",
	"patient.portal.conditions.resolved": "Resolved",
	"patient.portal.data.emptyState": "No {type}",
	"patient.portal.data.noActiveMedications": "No Active Medications.",
	"patient.portal.data.noActiveMedications.tap": "Tap Show Inactive to view previous data.",
	"patient.portal.labTestResult.modalTitle": "Test Results Details",
	"patient.portal.labTestResult.result": "Result",
	"patient.portal.labTestResult.noDetected": "No Detected",
	"patient.portal.labTestResult.detected": "Detected",
	"patient.portal.labTestResult.availablePdfIvy": "You will receive a notification when the report is available",
	"patient.portal.labTestResult.normalState": "Normal State",
	"patient.portal.labTestResult.normalRange": "Normal Range",
	"patient.portal.labTestResult.normalRangeState": "Normal Range/State",
	"patient.portal.labTestResult.low": "Low",
	"patient.portal.labTestResult.normal": "Normal",
	"patient.portal.labTestResult.high": "High",
	"patient.portal.emptyState.addData": "Add {type}",
	"patient.portal.emptyState.bodyInfo": "Body Info",
	"patient.portal.emptyState.stepsOrDistance.noData": "No activity data",
	"patient.portal.emptyState.stepsOrDistance.addAccount": "Would you like to add a device account?",
	"patient.portal.emptyState.goToSettings": "Go to Settings",
	"patient.portal.diagnosis": "Diagnosis",
	"patient.portal.errorTime": "Cannot set time to be in the future.",
	"patient.portal.healthRecord.emptyState.nothingFound": "Nothing found",
	"patient.portal.healthRecord.emptyState.tryToChoose": "Try to choose a different period",
	"patient.portal.healthRecord.dateRange": "Date range",
	"patient.portal.healthRecord.search": "Search",
	"patient.portal.healthRecord.openAsCCD": "Open as CCD",
	"patient.portal.healthRecord.openAsPDF": "Open as PDF",
	"patient.portal.healthRecord.openAs": "Open as {fileType}",
	"patient.portal.healthRecord.downloadAsCCD": "Download as CCD",
	"patient.portal.healthRecord.downloadAsPDF": "Download as PDF",
	"patient.portal.healthRecord.downloadAsZIP": "Download as ZIP",
	"patient.portal.healthRecord.downloadAs": "Download as {fileType}",
	"patient.portal.healthRecord.shareToChat": "Share to Chat",
	"patient.portal.healthRecord.shareToEmail": "Share to E-mail",
	"patient.portal.healthRecord.shareToChatSuccess": "You have shared the link to {recipient}",
	"patient.portal.healthRecord.shareToEmailSuccess": "E-mail sent",
	"patient.portal.healthRecord.shareToEmail.description": "Share your health record by emailing a link.",
	"patient.portal.healthRecord.shareToEmailRecipient": "Recipient E-mail",
	"patient.portal.healthRecord.shareToEmail.validationMsg": "Invalid format. Please reenter the email address using the standard format: example@example.com",
	"patient.portal.healthRecord.shareToEmail.confirmTitle": "The e-mail will be sent to {recipient}.",
	"patient.portal.healthRecord.shareToEmail.confirmQuestion": "Are you sure?",
	"patient.portal.healthRecord.shareToEmail.confirmButton": "Yes, send e-mail",
	"patient.portal.healthRecord.activityLog.seeMembers": "See members",
	"patient.portal.healthRecord.activityLog.you": "You",
	"patient.portal.healthRecord.activityLog.guardianProxy": "Guardian/Proxy",
	"patient.portal.healthRecord.activityLog.patient": "Patient",
	"patient.portal.healthRecord.activityLog.viewed": "viewed",
	"patient.portal.healthRecord.activityLog.downloaded": "downloaded",
	"patient.portal.healthRecord.activityLog.transmitted": "transmitted",
	"patient.portal.healthRecord.activityLog.to": "to",
	"patient.portal.healthRecord.activityLog.user": "User",
	"patient.portal.healthRecord.activityLog.chatMembers": "Chat members",
	"patient.portal.procedures": "Procedures",
	"patient.portal.requestRefills": "Request Refill",
	"patient.portal.refillHistory": "Refill History",
	"patient.portal.unavailablePharmacy": "Something went wrong. Please update the data or contact support.",
	"patient.portal.selectMedications": "Select Medications",
	"patient.portal.requestRefillProvider": "Please contact your Provider to request a refill for medications.",
	"patient.portal.requestRefillNotification": "Please allow for 72 hours for this request\n to be processed.",
	"program.card.leave": "Leave Program",
	"program.card.leave.title": "Are you sure you want to leave program?",
	"program.card.leave.body": "You will lose access to the benefits of the program.",
	"program.card.leave.body.ar": "{dependentName} will lose access to the benefits of the program.",
	"program.consent.for": "Consent For {name}",
	"program.consent.subtitle": "Program Consent",
	"program.consent.title": "Sign consent before accept invitation",
	"program.invite.title": "{name} program",
	"program.invite.programCost": "Program Cost:",
	"program.invite.details.title": "Join to Program",
	"program.invite.details.descriptionTitle": "About the program",
	"program.invite.details.titleInvite": "has invited you to join {name} program.",
	"program.invite.notification.removed": "Invite was removed",
	"program.invite.notification.joined": "You have joined the program",
	"program.invite.notification.joinedAR": "{dependentName} has joined the program",
	"program.invite.notification.declined": "Program Invite was declined",
	"program.invite.notification.completed": "Invite is already completed",
	"paya.payment.amount": "Amount",
	"paya.payment.startDate": "Start date",
	"paya.payment.card": "Card",
	"paya.payment.addNewPaymentMethod": "Add Payment Method",
	"paya.payment.submitPayment": "Submit Payment",
	"paya.payment.cardAgreement": "I agree to pay the above total according to my card issuer agreement",
	"paya.payment.automaticallyRenew": "I agree to automatically renew my membership and authorize reoccurring charges to this card until I elect to cancel my membership.",
	"paya.payment.transactionDescription": "By authorizing this transaction, customer agrees that merchant may convert this transaction into an Electronic Funds Transfer (EFT) transaction or paper draft, and to debit this account for the amount of the transaction. Additionally, in the event this draft or EFT is returned unpaid, a service fee, as allowable by law, will be charged to this account via EFT or draft. In the event you choose to revoke this authorization, please do so by contacting the merchant directly. Please note that processing times may not allow for revocation of this authorization.",
	"program.membership.pay": "Pay",
	"program.membership.payaAccountForm.title": "Add Payment Method",
	"program.membership.payaResponse.static": "The payment was unsuccessful and your card was not charged. Please try again.",
	"program.membership.payaResponse.success": "You have joined {programName} program.",
	"program.membership.payaResponse.dependent.success": "{dependentName} has joined {programName} program.",
	"program.membership.title": "Membership",
	"program.membership.nextPayment": "Next payment",
	"program.membership.paymentDue": "Payment due",
	"program.membership.prepaid": "(paid)",
	"program.membership.prepay": "Prepay next period",
	"program.membership.prepay.success": "Your membership has been updated",
	"program.membership.prepay.dependent.success": "{dependentName}`s membership has been updated",
	"visitType.urgentCare.description": "If you think you or a family member is having a medical or psychiatric emergency, call 911. Do not attempt to access emergency care through this app.",
	"visitType.locations": "{name} Locations",
	"visitType.publix": "Publix",
	"visitType.publix.title": "How it works",
	"appointmentForm.appointmentLocations.waitTime": "Wait time",
	"appointmentForm.appointmentLocations.minutes": "minutes",
	"appointmentForm.rescheduleFlow.notification": "This Provider has only virtual visits available.",
	"appointmentForm.rescheduleFlow.notification.onlineVisit": "online visit",
	"appointmentForm.rescheduleFlow.notification.warning": "Please note this visit is an {visit}. You do not need to go the location.",
	"paperwork": "Paperwork",
	"paperwork.dob.title": "Confirm date of birth",
	"paperwork.dob.description": "For the patient's privacy, please confirm their date of birth to continue.",
	"paperwork.dob.fieldLabel": "Patient's date of birth",
	"paperwork.dob.confirm": "Confirm",
	"paperwork.dob.agreeWithTermsAndPolicy": "By clicking “Confirm” you agree to our {terms} and {policy}.",
	"paperwork.error.appointmentUnavailable": "The information you entered doesn't match any upcoming visit.",
	"paperwork.signConsent": "Sign Consent",
	"paperwork.submit": "Submit Paperwork",
	"paperwork.insuranceDetails": "Insurance Details",
	"paperwork.signConsentBeforeVisit": "Sign Consent before the Visit",
	"paperwork.upcomingVisitDetails": "Upcoming Visit Details",
	"paperwork.error.verifyDob.invalidDob": "We couldn't verify the date of birth. Please check the entered date and try again. If this keeps happening, contact support for assistance.",
	"paperwork.button.complete": "Complete Paperwork",
	"paperwork.visitPrepMessage": "This helps your provider prepare and ensures a smoother experience.",
	"paperwork.requiredInfoNote": " Please fill out the required information in ",
	"paperwork.canceledVisit": "Canceled",
	"paperwork.editPaperwork": "Edit Paperwork",
	"paperwork.completed": "Pre-visit paperwork completed",
	"paperwork.completed.label": "Pre-visit paperwork has been successfully saved — you're all set for your visit!",
	"paperwork.completed.info": "You can review/edit your information below or close this page at anytime.",
	"paperwork.section.pcpSectionTitle": "Primary Care Provider",
	"paperwork.section.yourPCPName": "Your PCP's name",
	"paperwork.dialog.resendCode": "Resend code {counter} sec.",
	"paperwork.dialog.verifyingLink": "Verifying your link\n and protecting your data",
	"paperwork.modal.confirmDeleteInsurance": "Are you sure you want to delete this insurance?",
	"paperwork.modal.deleteInsuranceWarning": "The insurance data you entered will not be saved.",
	"payment.accountForm.cardNotPermitted": "Card Not Permitted",
	"other.goToMozzaz": "Portal"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 5357
// module chunks = 39